import React, { Component } from 'react';
import PropTypes from 'prop-types';
import URLSearchParams from '@ungap/url-search-params'
import {
    SetComponentLanguage,
    ApiRequest,
    DeepCopy,
    GroupBy,
    parsePrinterXML,
    Debounce,
    ReturnTimeZone
} from '../../helpers';
import Cart from '../Cart/Cart';
import EventCategory from './EventCategory/EventCategory';
import EventBilling from './EventBilling/EventBilling';
import ReservedSeating from './ReservedSeating/ReservedSeating';
import GeneralSeating from './GeneralSeating/GeneralSeating';
import EventCustomer from './EventCustomer/EventCustomer';
import EventConfirmation from './EventConfirmation/EventConfirmation';
import ConfirmDeleteEventModal from '../Common/ConfirmDeleteEventModal/ConfirmDeleteEventModal';
import ConfirmDeleteFlexpassModal from '../Common/ConfirmDeleteFlexpassModal/ConfirmDeleteFlexpassModal';
import ConfirmEarlyPayoutModal from './ConfirmEarlyPayoutModal/ConfirmEarlyPayoutModal';
import EventWidgetModal from './EventWidgetModal/EventWidgetModal';
import BrowserNotSupportedModal from './BrowserNotSupportedModal/BrowserNotSupportedModal';
import StreamingWarningModal from './StreamingWarningModal/StreamingWarningModal';
import StripeDeviceSelect from './StripeDeviceSelect/StripeDeviceSelect';
import PasswordModal from './PasswordModal/PasswordModal';
import TimerUpModal from './TimerUpModal/TimerUpModal';
import NoTicketsModal from './NoTicketsModal/NoTicketsModal';
import FlexpassDetailsModal from './FlexpassDetailsModal/FlexpassDetailsModal';
import Message from '../Common/Message/Message';
import Dymo from '../../lib/labels/dymojs';
import Boca from '../../lib/labels/boca';
import Star from '../../lib/labels/star';
import LocalizedStrings from 'react-localization';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './EventListing.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);
let terminal = window.StripeTerminal
let stripePromise;

class EventListing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            billing: {
                method: 'card',
                check: ''
            },
            isCustomerEditingMode: false,
            customer: {
                search: '',
                email: '',
                first_name: '',
                last_name: '',
                mailing_list: false,
                email_list: true,
                address_1: '',
                address_2: '',
                city: '',
                country: 'US',
                state: '',
                zip: '',
                phone: ''
            },
            customers: null,
            tags: [],
            selectedTags: [],
            questions: [],
            events: [],
            flexpasses: [],
            client: {},
            categories: [
                {
                    name: "active"
                },
                {
                    name: "pending"
                },
                {
                    name: "past"
                }
            ],
            isCategoryOpen:  {
                active: false,
                pending: false,
                past: false
            },
            isTicketsOpen: false,
            isBillingOpen : false,
            isCustomerInfoOpen: false,
            isConfirmationOpen: false,
            confirmationNumber: '',
            stripe_token: '',
            stripe_publishable_key: '',
            ticketSelection : {
                artists: [],
                tickets: []
            },
            max_seats: 0,
            validation: {
                billing: {
                    donation: {
                        valid: true,
                        msg: ''
                    },
                    check: {
                        valid: true,
                        msg: ''
                    }
                },
                customer: {
                    email: {
                        valid: !this.props.user.role ? null : true,
                        msg: ''
                    },
                    address_1: {
                        valid: null,
                        msg: ''
                    },
                    city: {
                        valid: null,
                        msg: ''
                    },
                    country: {
                        valid: true,
                        msg: ''
                    },
                    state: {
                        valid: true,
                        msg: ''
                    },
                    first_name: {
                        valid: null,
                        msg: ''
                    },
                    last_name: {
                        valid: null,
                        msg: ''
                    },
                    zip: {
                        valid: null,
                        msg: ''
                    },
                    phone: {
                        valid: true,
                        msg: ''
                    }
                }
            }, 
            isReadyToSubmit: false,
            lastShowSelected: '',
            lastShowDateSelected: '',
            lastShowType: '',
            lastPaymentMethod: '',
            lastShippingMethod: '',
            isDeleteEventOpen: false,
            isDeleteFlexpassOpen: false,
            isEarlyPayoutOpen: false,
            isTimerUpOpen: false,
            isNoTicketsOpen: false,
            isPasswordOpen: false,
            isPasswordOpenFromUrl: false,
            eventPasswordId: undefined,
            flexpassPasswordId: undefined,
            datePasswordId: undefined,
            showEarlyPayoutConfirmation: false,
            eventIdToEarlyPayout: undefined,
            isQueue: false,
            refresh: false,
            printers: [],
            currentPrinter: '',
            printersBoca: [],
            currentPrinterBoca: '',
            cartItems: [],
            cartPricing: {},
            call_center_fee: true,
            service_fee: 'default',
            fees_and_discounts: {
                donation: 0,
                couponFlexpass: '',
                validCoupon: null,
                flexpass: {
                    amount: 1,
                    validFlexpass: null
                },
                shipping: ''
            },
            disablePhysicalMailingOption: false,
            message: {
                title: '',
                content: '',
                type: ''
            },
            isReset: false,
            patronTicketURL: null,
            checkoutInProgress: false,
            isCheckoutDisabled: false,
            isToggleWidgetModalOpen: false,
            widgetModalEventID: 0,
            widgetModalEventName: "",
            isBrowserNotSupportedModalOpen: false,
            confirmationEvent: {
                name: '',
                id: '',
            },
            hasQuestionNotAnswered: false,
            isVODWarning: false,
            isScheduledContentWarning: false,
            isLiveStreamingWarning: false,
            selectedEvent: {},
            selectedDate: {},
            isStripeDeviceSelectOpen: false,
            isTerminalConnected: false,
            token: '',
            limit: {
                active: 50,
                pending: 50,
                past: 8,
            },
            page: {
                active: 0,
                pending: 0,
                past: 0,
            },
            previousPastEventsLength: 0,
            currentPrinterStar: '',
            printersStar: [],
            printersStarUSB: [],
            isFlexpassDetailsModalOpen: false,
            flexpassDetails: {
                events: [],
                name: '',
                description: '',
                max_tickets: 0,
                tickets_remaining: 0,
            },
            allEvents: [],
            stripeRequestPayment: '',
            isPaymentEnabled: true,
        };
    }

    searchCustomers = async (searchTerm) => {
        try {
            const responseCustomers = await getCustomers(searchTerm);
            console.log('Get Customers Response: ', responseCustomers.data.customers);
            this.setState({ 
                customers: responseCustomers.data.customers,
            });
        } catch (error) {
            console.log(error)
        }
        
        async function getCustomers(searchTerm) {
            return await ApiRequest(`/customers?search=${searchTerm}`);
        }
    }

    returnStripeToken = (token, stripePublishableKey) => {
        console.log(stripePublishableKey);
        this.setState({ 
            stripe_token: token && token.token && token.token.id,
            stripe_publishable_key: stripePublishableKey
        }, () => this.checkout());
    }

    checkoutStripePayment = async (pr, stripe, paymentMethod, data, complete) => {
        this.setMessage('', '', 'loading');
        this.setState({ 
            isBillingOpen: false,
        });
        console.log('checkoutStripePayment')
        
        console.log('pr', pr)
        console.log('stripe', stripe)
        console.log('paymentMethod', paymentMethod)
        console.log('data', data)


        if (!this.state.checkoutInProgress) {
            try {
                this.setState({ 
                    checkoutInProgress: true,
                    stripe_publishable_key: stripe._apiKey,
                    //stripe_token: token && token.token && token.token.id,
                }, async () => {
                    const responseCheckout = await postCheckout(this.state, this.props, data);
                    console.log('==============Post tickets for checkout: ', responseCheckout);
                    if (responseCheckout.data.stripe_intent_secret) {
                        this.setState({ checkoutInProgress: false });
                       
                        const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
                            responseCheckout.data.stripe_intent_secret,
                            { payment_method: paymentMethod.id },
                        );

                        console.log('paymentIntent', paymentIntent)
                        console.log('confirmError', confirmError)
                    
                        if (confirmError) {
                            this.setState({
                                stripeRequestPayment: 'fail',
                                isBillingOpen: true,
                            });
                            this.setMessage('Oops!', 'The payment failed -- ask your customer for a new payment method.', 'error');
                        } else {
                            console.log('success');
                            this.setState({
                                stripeRequestPayment: 'success',
                            })
                            // Report to the browser that the confirmation was successful, prompting
                            // it to close the browser payment method collection interface.
                            //complete('success');
                            // Check if the PaymentIntent requires any actions and if so let Stripe.js
                            // handle the flow. If using an API version older than "2019-02-11"
                            // instead check for: `paymentIntent.status === "requires_source_action"`.
                            if (paymentIntent.status === "requires_action") {
                                // Let Stripe.js handle the rest of the payment flow.
                                const { error } = await stripe.confirmCardPayment(responseCheckout.data.stripe_intent_secret);
                                if (error) {
                                    //alert('// The payment failed -- ask your customer for a new payment method.');
                                    this.setMessage('Oops!', 'The payment failed -- ask your customer for a new payment method.', 'error');
                                    this.setMessage('', '', '');
                                } else {
                                    // if payment was successful
                                    try {
                                        const stripeResponseCheckout = await postStripeCheckout(responseCheckout.data);
                                        console.log('==============Stripe response checkout: ', stripeResponseCheckout);
            
                                        if (!stripeResponseCheckout.data.error) {
                                            const patronTicketURL = stripeResponseCheckout.data.ticket_url || null;
                                            const lastShowSelected = this.state.ticketSelection.id;
                                            const lastShowDateSelected = this.state.ticketSelection.dateIndex;
                                            const lastShowType = this.state.ticketSelection.type;
                                            const lastPaymentMethod = this.state.billing.method;
                                            const lastShippingMethod = this.state.fees_and_discounts.shipping;
                                            const currentPrinterStar = localStorage.getItem('defaultStarPrinter') || this.state.currentPrinterStar;
                                            const printersStar = this.state.printersStar;
                                            const printersStarUSB = this.state.printersStarUSB;
                                            let confirmationEvent = {};
                                            confirmationEvent.name = this.state.ticketSelection.name;
                                            confirmationEvent.id = this.state.ticketSelection.id;
                                            confirmationEvent.event_type = this.state.ticketSelection.event_type;
                                            this.setState(DeepCopy(this.baseState), () => {
                                                this.setState({
                                                    confirmationNumber: String(stripeResponseCheckout.data.transaction_id),
                                                    isConfirmationOpen: true,
                                                    lastShowSelected,
                                                    lastShowDateSelected,
                                                    lastShowType,
                                                    lastPaymentMethod,
                                                    lastShippingMethod,
                                                    patronTicketURL,
                                                    confirmationEvent,
                                                    token: stripeResponseCheckout.data.token,
                                                    currentPrinterBoca: localStorage.getItem('defaultBocaPrinter') || this.state.currentPrinterBoca,
                                                    currentPrinterStar,
                                                    printersStar,
                                                    printersStarUSB,
                                                }, () => {
                                                    window.scrollTo(0, 0)
                                                    this.resetFeesAndDiscounts();
                                                    this.setMessage('', '', '');
                                                    this.setState({
                                                        checkoutInProgress: false,
                                                        isReset: true,
                                                    });
                                                });
                                            });
                                        } else {
                                            window.scrollTo(0, 0);
                                            let userRole = this.props.user.role ? this.props.user.role : 'patron';
                                            let stripeMessage = stripeResponseCheckout.data.error.stripe_error ? ` ${stripeResponseCheckout.data.error.stripe_error.message}` : '';
                                            let stripeDeclineCode = stripeResponseCheckout.data.error.stripe_error ? ` ${stripeResponseCheckout.data.error.stripe_error.decline_code}` : '';
                                            let stripeErrorCode = stripeResponseCheckout.data.error.stripe_error ? ` ${stripeResponseCheckout.data.error.stripe_error.code}` : '';
                                            let path = stripeResponseCheckout.data.error.path ? stripeResponseCheckout.data.error.path : '';
                                            let validationError = stripeResponseCheckout.data.error.details ? stripeResponseCheckout.data.error.details : '';
                                            this.setMessage(window.general_strings.msg.oops, `Please report this error: ${stripeResponseCheckout.data.error.code}${stripeMessage}${stripeDeclineCode}${stripeErrorCode}${validationError}, path: ${path}, user role: ${userRole},  billing country: ${this.state.client.billing_country}`, 'error');
                                            setTimeout(() => {
                                                this.setMessage('', '', '');
                                                this.setState({ 
                                                    checkoutInProgress: false,
                                                    isBillingOpen: true,
                                                });
                                            }, 10000);
                                        }
                                    } catch (error) {
                                        console.log(error);
                                        this.setState({ 
                                            isBillingOpen: true,
                                        });
                                        this.setMessage(window.general_strings.msg.oops, `Error processing payment: ${error}`, 'error');
                                    }
            
                                    async function postStripeCheckout(props) {
                                        let data = {};
                                        data['stripe_intent_id'] = props.stripe_intent_id;
                                        data['transaction_id'] = props.transaction_id;
                                        return await ApiRequest(`/tickets/checkout/complete`, {
                                            method: 'POST',
                                            data
                                        });
                                    }
                                }
                            } else {
                                // if payment was successful
                                try {
                                    const stripeResponseCheckout = await postStripeCheckout(responseCheckout.data);
                                    console.log('==============Stripe response checkout: ', stripeResponseCheckout);
        
                                    if (!stripeResponseCheckout.data.error) {
                                        const patronTicketURL = stripeResponseCheckout.data.ticket_url || null;
                                        const lastShowSelected = this.state.ticketSelection.id;
                                        const lastShowDateSelected = this.state.ticketSelection.dateIndex;
                                        const lastShowType = this.state.ticketSelection.type;
                                        const lastPaymentMethod = this.state.billing.method;
                                        const lastShippingMethod = this.state.fees_and_discounts.shipping;
                                        const currentPrinterStar = localStorage.getItem('defaultStarPrinter') || this.state.currentPrinterStar;
                                        const printersStar = this.state.printersStar;
                                        const printersStarUSB = this.state.printersStarUSB;
                                        let confirmationEvent = {};
                                        confirmationEvent.name = this.state.ticketSelection.name;
                                        confirmationEvent.id = this.state.ticketSelection.id;
                                        confirmationEvent.event_type = this.state.ticketSelection.event_type;
                                        this.setState(DeepCopy(this.baseState), () => {
                                            this.setState({
                                                confirmationNumber: String(stripeResponseCheckout.data.transaction_id),
                                                isConfirmationOpen: true,
                                                lastShowSelected,
                                                lastShowDateSelected,
                                                lastShowType,
                                                lastPaymentMethod,
                                                lastShippingMethod,
                                                patronTicketURL,
                                                confirmationEvent,
                                                token: stripeResponseCheckout.data.token,
                                                currentPrinterBoca: localStorage.getItem('defaultBocaPrinter') || this.state.currentPrinterBoca,
                                                currentPrinterStar,
                                                printersStar,
                                                printersStarUSB,
                                            }, () => {
                                                window.scrollTo(0, 0)
                                                this.resetFeesAndDiscounts();
                                                this.setMessage('', '', '');
                                                this.setState({
                                                    checkoutInProgress: false,
                                                    isReset: true,
                                                });
                                            });
                                        });
                                    } else {
                                        window.scrollTo(0, 0);
                                        let userRole = this.props.user.role ? this.props.user.role : 'patron';
                                        let stripeMessage = stripeResponseCheckout.data.error.stripe_error ? ` ${stripeResponseCheckout.data.error.stripe_error.message}` : '';
                                        let stripeDeclineCode = stripeResponseCheckout.data.error.stripe_error ? ` ${stripeResponseCheckout.data.error.stripe_error.decline_code}` : '';
                                        let stripeErrorCode = stripeResponseCheckout.data.error.stripe_error ? ` ${stripeResponseCheckout.data.error.stripe_error.code}` : '';
                                        let path = stripeResponseCheckout.data.error.path ? stripeResponseCheckout.data.error.path : '';
                                        let validationError = stripeResponseCheckout.data.error.details ? stripeResponseCheckout.data.error.details : '';
                                        this.setMessage(window.general_strings.msg.oops, `Please report this error: ${stripeResponseCheckout.data.error.code}${stripeMessage}${stripeDeclineCode}${stripeErrorCode}${validationError}, path: ${path}, user role: ${userRole},  billing country: ${this.state.client.billing_country}`, 'error');
                                        setTimeout(() => {
                                            this.setMessage('', '', '');
                                            this.setState({ 
                                                checkoutInProgress: false,
                                                isBillingOpen: true,
                                            });
                                        }, 10000);
                                    }
                                } catch (error) {
                                    console.log(error);
                                    this.setState({ 
                                        isBillingOpen: true,
                                    });
                                    this.setMessage(window.general_strings.msg.oops, `Error processing payment: ${error}`, 'error');
                                }
        
                                async function postStripeCheckout(props) {
                                    let data = {};
                                    data['stripe_intent_id'] = props.stripe_intent_id;
                                    data['transaction_id'] = props.transaction_id;
                                    return await ApiRequest(`/tickets/checkout/complete`, {
                                        method: 'POST',
                                        data
                                    });
                                }
                            }
                        }
                    }
                });
            } catch (error) {
                console.log(error);
            }
        };

        async function postCheckout(state, props, _data) {
            console.log('postCheckout state', state);
            let query;
            if(props.user.role) {
                if (state.billing.method === 'reserved') {
                    query = '/box-office/reserve';
                } else if (state.billing.method === 'vipatron') {
                    query = '/box-office/vipatron';
                } else {
                    query = '/box-office/checkout';
                }
            } else {
                query = '/tickets/checkout';
            }
            
            // Build the checkout objects for validation
            let data = {};
            
            data['type'] = state.cartPricing.txn_gross !== 0 ? state.billing.method : 'cash';
            data['shipping_method'] = state.fees_and_discounts.shipping;
            data['call_center_fee'] = state.call_center_fee;
            data['service_fee'] = state.service_fee !== 'default' ? state.service_fee : undefined;
            data['donation'] = parseFloat(state.fees_and_discounts.donation);
            data['billing_country'] = state.client.billing_country;


            // Modify the customer
            data['customer'] = {};
            data['customer']['email'] = _data.payerEmail;
            data['customer']['first_name'] = _data.payerName.split(' ')[0];
            data['customer']['last_name'] = _data.payerName.split(' ')[1];

            // Conditional fields
            state.ticketSelection.artistId ? data['credit_artist_id'] = parseInt(state.ticketSelection.artistId, 0) : false;
            state.ticketSelection.tag_ids !== [] ? data['tag_ids'] = state.selectedTags.map(tag => tag.id) : false;
            state.fees_and_discounts.flexpass.validFlexpass !== null ? data['flexpass_redemption'] = { code: state.fees_and_discounts.flexpass.validFlexpass, amount: parseFloat(state.fees_and_discounts.flexpass.amount) } : false;
            state.fees_and_discounts.validCoupon !== null ? data['coupon_redemption'] = { code: state.fees_and_discounts.validCoupon } : false;
            state.stripe_token !== '' ? data['stripe_token'] = state.stripe_token : false;
            state.stripe_publishable_key !== '' ? data['stripe_publishable_key'] = state.stripe_publishable_key : false;

            // Answers
            let dataAnswers = [];
            const questions = state.questions;
            questions.forEach((question) => {
                if (question.answer !== "") {
                    let newAnswer = {};
                    newAnswer.answer = question.answer;
                    newAnswer.client_question_id = question.id;
                    dataAnswers.push(newAnswer);
                }
            });
            data['answers'] = dataAnswers;

            data['use_stripe_intents'] = true;

            console.log('data', data);
            return await ApiRequest(`${query}`, {
                method: 'POST',
                data
            });
        }
    }

    checkout = async () => {
        this.setMessage('', '', 'loading');
        if (!this.state.checkoutInProgress) {
            try {
                this.setState({ checkoutInProgress: true });
                const responseCheckout = await postCheckout(this.state, this.props);
                console.log('==============Post tickets for checkout: ', responseCheckout);
                if (!responseCheckout.data.error) {

                    // If Stripe checkout
                    if (this.state.billing.method === 'reader') {

                        // Collect Payment from the Reader, causes reader screen to update with info
                        const collectPaymentResponse = await terminal.collectPaymentMethod(responseCheckout.data.stripe_intent_secret);
                        console.log('==============collectPaymentResponse: ', collectPaymentResponse);

                        if (collectPaymentResponse.error) {
                            this.setMessage(window.general_strings.msg.oops, `Error collecting payment: ${collectPaymentResponse.error.message}`, 'error');
                            console.log('collectPaymentResponse.error', collectPaymentResponse.error);
                            // Placeholder for handling result.error
                            this.setState({ checkoutInProgress: false });
                        } else {
                            // Placeholder for processing result.paymentIntent
                            const processPaymentResponse = await terminal.processPayment(collectPaymentResponse.paymentIntent);
                            console.log('==============processPaymentResponse: ', processPaymentResponse);
                            if (processPaymentResponse.error) {
                                this.setMessage(window.general_strings.msg.oops, `Error processing payment: ${processPaymentResponse.error.message}`, 'error');
                                console.log('processPaymentResponse.error', processPaymentResponse.error);
                                this.setState({ checkoutInProgress: false });
                                // Placeholder for handling result.error
                            } else if (processPaymentResponse.paymentIntent) {
                                // if payment was successful
                                if (processPaymentResponse.paymentIntent.status === 'requires_capture') {
                                    try {
                                        const stripeResponseCheckout = await postStripeCheckout(responseCheckout.data);
                                        console.log('==============Stripe response checkout: ', stripeResponseCheckout);
            
                                        if (!stripeResponseCheckout.data.error) {
                                            const patronTicketURL = stripeResponseCheckout.data.ticket_url || null;
                                            const lastShowSelected = this.state.ticketSelection.id;
                                            const lastShowDateSelected = this.state.ticketSelection.dateIndex;
                                            const lastShowType = this.state.ticketSelection.type;
                                            const lastPaymentMethod = this.state.billing.method;
                                            const lastShippingMethod = this.state.fees_and_discounts.shipping;
                                            const currentPrinterStar = localStorage.getItem('defaultStarPrinter') || this.state.currentPrinterStar;
                                            const printersStar = this.state.printersStar;
                                            const printersStarUSB = this.state.printersStarUSB;
                                            let confirmationEvent = {};
                                            confirmationEvent.name = this.state.ticketSelection.name;
                                            confirmationEvent.id = this.state.ticketSelection.id;
                                            confirmationEvent.event_type = this.state.ticketSelection.event_type;
                                            this.setState(DeepCopy(this.baseState), () => {
                                                this.setState({
                                                    confirmationNumber: String(stripeResponseCheckout.data.transaction_id),
                                                    isConfirmationOpen: true,
                                                    lastShowSelected,
                                                    lastShowDateSelected,
                                                    lastShowType,
                                                    lastPaymentMethod,
                                                    lastShippingMethod,
                                                    patronTicketURL,
                                                    confirmationEvent,
                                                    token: stripeResponseCheckout.data.token,
                                                    currentPrinterBoca: localStorage.getItem('defaultBocaPrinter') || this.state.currentPrinterBoca,
                                                    currentPrinterStar,
                                                    printersStar,
                                                    printersStarUSB,
                                                }, () => {
                                                    window.scrollTo(0, 0)
                                                    this.resetFeesAndDiscounts();
                                                    this.setState({
                                                        checkoutInProgress: false,
                                                        isReset: true,
                                                    });
                                                });
                                            });
                                        } else {
                                            window.scrollTo(0, 0);
                                            let userRole = this.props.user.role ? this.props.user.role : 'patron';
                                            let stripeMessage = stripeResponseCheckout.data.error.stripe_error ? ` ${stripeResponseCheckout.data.error.stripe_error.message}` : '';
                                            let stripeDeclineCode = stripeResponseCheckout.data.error.stripe_error ? ` ${stripeResponseCheckout.data.error.stripe_error.decline_code}` : '';
                                            let stripeErrorCode = stripeResponseCheckout.data.error.stripe_error ? ` ${stripeResponseCheckout.data.error.stripe_error.code}` : '';
                                            let path = stripeResponseCheckout.data.error.path ? stripeResponseCheckout.data.error.path : '';
                                            let validationError = stripeResponseCheckout.data.error.details ? stripeResponseCheckout.data.error.details : '';
                                            this.setMessage(window.general_strings.msg.oops, `Please report this error: ${stripeResponseCheckout.data.error.code}${stripeMessage}${stripeDeclineCode}${stripeErrorCode}${validationError}, path: ${path}, user role: ${userRole},  billing country: ${this.state.client.billing_country}`, 'error');
                                            setTimeout(() => {
                                                this.setMessage('', '', '');
                                                this.setState({ checkoutInProgress: false });
                                            }, 10000);
                                        }
                                    } catch (error) {
                                        console.log(error);
                                        this.setMessage(window.general_strings.msg.oops, `Error processing payment: ${error}`, 'error');
                                    }
            
                                    async function postStripeCheckout(props) {
                                        let data = {};
                                        data['stripe_intent_id'] = props.stripe_intent_id;
                                        data['transaction_id'] = props.transaction_id;
                                        return await ApiRequest(`/box-office/checkout/complete`, {
                                            method: 'POST',
                                            data
                                        });
                                    }
                                }
                            }
                        }
                    } else {
                        const patronTicketURL = responseCheckout.data.ticket_url || null;
                        const lastShowSelected = this.state.ticketSelection.id;
                        const lastShowDateSelected = this.state.ticketSelection.dateIndex;
                        const lastShowType = this.state.ticketSelection.type;
                        const lastPaymentMethod = this.state.billing.method;
                        const lastShippingMethod = this.state.fees_and_discounts.shipping;
                        const currentPrinterStar = localStorage.getItem('defaultStarPrinter') || this.state.currentPrinterStar;
                        const printersStar = this.state.printersStar;
                        const printersStarUSB = this.state.printersStarUSB;
                        let confirmationEvent = {};
                        confirmationEvent.name = this.state.ticketSelection.name;
                        confirmationEvent.id = this.state.ticketSelection.id;
                        confirmationEvent.event_type = this.state.ticketSelection.event_type;
                        this.setState(DeepCopy(this.baseState), () => {
                            this.setState({
                                confirmationNumber: String(responseCheckout.data.transaction_id),
                                isConfirmationOpen: true,
                                lastShowSelected,
                                lastShowDateSelected,
                                lastShowType,
                                lastPaymentMethod,
                                lastShippingMethod,
                                patronTicketURL,
                                confirmationEvent,
                                token: responseCheckout.data.token,
                                currentPrinterBoca: localStorage.getItem('defaultBocaPrinter') || this.state.currentPrinterBoca,
                                currentPrinterStar,
                                printersStar,
                                printersStarUSB,
                            }, () => {
                                window.scrollTo(0, 0)
                                this.resetFeesAndDiscounts();
                                this.setState({
                                    checkoutInProgress: false,
                                    isReset: true,
                                });
                            });
                        });
                    }
                    
                } else {
                    window.scrollTo(0, 0);
                    let userRole = this.props.user.role ? this.props.user.role : 'patron';
                    let stripeMessage = responseCheckout.data.error.stripe_error ? ` ${responseCheckout.data.error.stripe_error.message}` : '';
                    let stripeDeclineCode = responseCheckout.data.error.stripe_error ? ` ${responseCheckout.data.error.stripe_error.decline_code}` : '';
                    let stripeErrorCode = responseCheckout.data.error.stripe_error ? ` ${responseCheckout.data.error.stripe_error.code}` : '';
                    let path = responseCheckout.data.error.path ? responseCheckout.data.error.path : '';
                    let validationError = responseCheckout.data.error.details ? responseCheckout.data.error.details : '';
                    this.setMessage(window.general_strings.msg.oops, `Please report this error: ${responseCheckout.data.error.code}${stripeMessage}${stripeDeclineCode}${stripeErrorCode}${validationError}, path: ${path}, user role: ${userRole},  billing country: ${this.state.client.billing_country}`, 'error');
                    setTimeout(() => {
                        this.setMessage('', '', '');
                        this.setState({ checkoutInProgress: false });
                    }, 10000);
                }
            } catch (error) {
                console.log(error);
            }
        };

        // try {
        //     const ticketsInCartResponse = await this.getTicketsInCart(this.props.user);
        //     console.log('Tickets in cart: ', ticketsInCartResponse);
        // } catch (error) {
        //     console.log(error);
        // }

        async function postCheckout(state, props) {
            let query;
            if(props.user.role) {
                if (state.billing.method === 'reserved') {
                    query = '/box-office/reserve';
                } else if (state.billing.method === 'vipatron') {
                    query = '/box-office/vipatron';
                } else {
                    query = '/box-office/checkout';
                }
            } else {
                query = '/tickets/checkout';
            }
            
            // Build the checkout objects for validation
            let data = {};
            
            data['type'] = state.cartPricing.txn_gross !== 0 ? state.billing.method : 'cash';
            data['shipping_method'] = state.fees_and_discounts.shipping;
            data['call_center_fee'] = state.call_center_fee;
            data['service_fee'] = state.service_fee !== 'default' ? state.service_fee : undefined;
            data['donation'] = parseFloat(state.fees_and_discounts.donation);
            data['billing_country'] = state.client.billing_country;

            // If Stripe device
            if (state.billing.method === 'reader') {
                data['type'] = 'reader';
            }

            // Modify the customer
            const customer = { ...state.customer };
            delete customer.search;
            console.log(state.customer.first_name !== '' || state.customer.last_name !== '');
            state.customer.first_name !== '' || state.customer.last_name !== '' ? data['customer'] = customer : false;
            if (state.customer.email === '' && props.user.role && data.customer) {
                data['customer']['email'] = undefined;
            }
            state.customer.address_1 !== '' ? data['shipping_address'] = {
                address_1: state.customer.address_1,
                address_2: state.customer.address_2,
                city: state.customer.city,
                state: state.customer.state,
                zip: state.customer.zip,
                country: state.customer.country,
            } : false;

            // Conditional fields
            state.ticketSelection.artistId ? data['credit_artist_id'] = parseInt(state.ticketSelection.artistId, 0) : false;
            state.ticketSelection.tag_ids !== [] ? data['tag_ids'] = state.selectedTags.map(tag => tag.id) : false;
            state.fees_and_discounts.flexpass.validFlexpass !== null ? data['flexpass_redemption'] = { code: state.fees_and_discounts.flexpass.validFlexpass, amount: parseFloat(state.fees_and_discounts.flexpass.amount) } : false;
            state.fees_and_discounts.validCoupon !== null ? data['coupon_redemption'] = { code: state.fees_and_discounts.validCoupon } : false;
            state.stripe_token !== '' ? data['stripe_token'] = state.stripe_token : false;
            state.stripe_publishable_key !== '' ? data['stripe_publishable_key'] = state.stripe_publishable_key : false;

            // Answers
            let dataAnswers = [];
            const questions = state.questions;
            questions.forEach((question) => {
                if (question.answer !== "") {
                    let newAnswer = {};
                    newAnswer.answer = question.answer;
                    newAnswer.client_question_id = question.id;
                    dataAnswers.push(newAnswer);
                }
            });
            data['answers'] = dataAnswers;

            console.log(data);
            return await ApiRequest(`${query}`, {
                method: 'POST',
                data
            });
        }
    }

    sellMoreTickets = () => {
        this.populateTicketSelection(this.state.lastShowSelected, this.state.lastShowDateSelected, this.state.lastShowType);
        this.setState({ isConfirmationOpen: false });
    }

    continueShopping = () => {
        if (!this.props.user.role) {
            window.location.reload();
        } else {
            const isCategoryOpen = { ...this.state.isCategoryOpen }
            isCategoryOpen['active'] = true;
            this.setState({ 
                isConfirmationOpen: false,
                isCategoryOpen
            });
        }
    }

    selectCustomer = (position) => {
        const customer = {...this.state.customers[position]};
        const validation = {...this.state.validation}
        for (let key in customer) {
            if (validation['customer'].hasOwnProperty(key)) {
                validation['customer'][key]['valid'] = true;
            }
        }
        if (customer['country'] === null) {
            customer['country'] = '';
        }
        customer['search'] = '';
        if (this.state.disablePhysicalMailingOption) {
            customer['mailing_list'] = true;
        }
        const customers = null;
        let isCustomerEditingMode = { ...this.state.isCustomerEditingMode};
        isCustomerEditingMode = true;
        this.setState({ 
            customer,
            customers,
            isCustomerEditingMode,
            validation 
        }, () => this.validateAllRequiredFields());
    }

    invalidatePhysicalMailing = (inputs) => {
        const validation = { ...this.state.validation }
        inputs.map((input) => {
            if (validation['customer'].hasOwnProperty(input)) {
                validation['customer'][input]['valid'] = true;
            }
        })
        this.setState({ validation }, () => this.validateAllRequiredFields());
    }

    handleTicketSelection = (e, position, ticket) => {
        console.log('ticket', ticket);
        const quantity = e.target.value !== '' ? parseInt(e.target.value, 0) : '';
        const desc = e.target.name;
        const amount = parseFloat(e.target.attributes.getNamedItem('amount').value);
        const ticketSelection = {...this.state.ticketSelection};
        ticketSelection['tickets'][position] = {
            desc,
            amount,
            id : ticket.id || '',
            quantity,
            value : ticket.value ? ticket.value : ticket.visibility
        }
        console.log(ticketSelection);
        this.setState({ ticketSelection });
    }

    handleCreditsSelection = (e) => {
        const value = e.target.value;
        const ticketSelection = { ...this.state.ticketSelection };
        ticketSelection['artistId'] = value;
        this.setState({ ticketSelection });
    }

    connectToDevice = async (selectedDevice) => {
        let _this = this;
        
        async function fetchConnectionToken() {
            // Your backend should call /v1/terminal/connection_tokens and return the JSON response from Stripe
            const response = await fetch(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/stripe/reader/connection-token`, { 
                method: "POST",
                credentials: 'include'
            });
            const data = await response.json();
            return data.secret;
        }

        function unexpectedDisconnect() {
            alert('Connection lost! Please reconnect your reader.');
            sessionStorage.removeItem('connected_device');
            _this.setMessage('','','');
            let billing = _this.state.billing;
            billing.method = 'credit-card';
            _this.setState({
                billing,
                isTerminalConnected: false,
            });
        }

        terminal = window.StripeTerminal.create({
            onFetchConnectionToken: fetchConnectionToken,
            onUnexpectedReaderDisconnect: unexpectedDisconnect,
        });

        const connectResult = await terminal.connectReader(selectedDevice);
        if (connectResult.error) {
            _this.setMessage('Oops!', `Failed to connect: ${connectResult.error.message}`, 'error');
        } else {
            //_this.setMessage('Yay', `Connected to reader: ${connectResult.reader.label}`, 'success');
            sessionStorage.setItem('connected_device', JSON.stringify(selectedDevice));
            _this.setState({
                isTerminalConnected: true,
            });
        }
        setTimeout(() => {
            _this.setMessage('', ``, '');
        }, 5000);
    }

    handleEventBilling = async (e) => {
        e.persist();
        let value = e.target.value;
        const key = e.target.attributes.getNamedItem('object').value;
        const name = e.target.name;
        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, key, name, validationRegEx, e);
        }
        const billing = { ...this.state.billing };
        billing[name] = value;
        if (value !== 'vipatron' && value !== 'reserved') {
            if (value === 'check') {
                value = 'cash';
            }
            console.log('name', name)
            if (name !== 'check') {
                let isResetDonationAndCoupon = (name !== 'method');
                console.log('isResetDonationAndCoupon', isResetDonationAndCoupon)
                await this.resetFeesAndDiscounts(isResetDonationAndCoupon);
            }
            
            try {
                if (name !== 'check') {
                    const cartPricingResponse = await this.getCartPricing(this.props.user, value);
                    console.log('Cart pricing: ', cartPricingResponse);
                }
            } catch (error) {
                console.log(error);
            }
            
        }
        
        this.setState({ billing }, () => {
            if (value === 'reader') {
                if (sessionStorage.getItem('connected_device') === null) {
                    let isStripeDeviceSelectOpen = this.state.isStripeDeviceSelectOpen;
                    isStripeDeviceSelectOpen = true;
                    this.setState({
                        isStripeDeviceSelectOpen,
                    });
                } else {
                    this.connectToDevice(JSON.parse(sessionStorage.getItem('connected_device')));
                }
            } else {
                this.clearReaderDisplay();
            }
        });
    }

    handleCustomerAddress = (value) => {
        const customer = { ...this.state.customer };
        const validation = { ...this.state.validation };
        customer.address_1 = value;
        validation['customer']['address_1']['valid'] = value !== '';
        this.setState({ 
            customer,
            validation,
        });
    }

    handleFullCustomerAddress = (value) => {
        console.log(value);
    }

    formatPhoneNumber = (value) => {
        if (!value) return value;
        const phoneNumber = value.replace(/[^\d]/g, '');
        const phoneNumberLength = phoneNumber.length;
        if (phoneNumberLength < 4) return phoneNumber;
        if (phoneNumberLength < 7) {
          return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
        }
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
          3,
          6
        )}-${phoneNumber.slice(6, 10)}`;
      }

    handleCustomerInformation = (e) => {
        e.persist();
        let value = e.target.value;
        const key = e.target.attributes.getNamedItem('object').value;
        const name = e.target.name;
        const customer = { ...this.state.customer };
        if (e.target.type === "radio") {
            (value === "true") ? value = true : value = false;
        }
        if (name === 'country') {
            this.state.customer.country === 'US' ? customer['state'] = '' : customer['state'] = 'AB';
        }
        if (name === 'phone') {
            value = this.formatPhoneNumber(value);
        }
        customer[name] = value;
        this.setState({ customer });
        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, key, name, validationRegEx, e);
        }
    }

    handleChangeFilter = (id, tag_name) => {
        const selectedTags = [...this.state.selectedTags];
        const tag = {
            id:id,
            tag_name:tag_name
        };
        let index;
        for (let i = 0; i<selectedTags.length; i++) {
            if (parseInt(selectedTags[i].id) === parseInt(id)) {
                index = i;
            }
        }
        if(index >= 0) {
            selectedTags.splice(index, 1);
        } else {
            selectedTags.push(tag);
        }
        this.setState({ selectedTags });
    }

    handleChangeQuestionAnswer = (index, e) => {
        const questions = [...this.state.questions];
        questions[index].answer = e.target.value;
        let hasQuestionNotAnswered = false;
        questions.forEach((question) => {
            if (question.required && question.answer === '') {
                hasQuestionNotAnswered = true;
            }
        });
        this.setState({ 
            questions,
            hasQuestionNotAnswered,
        });
    }

    handlePrinterChange = (e) => {
        let value = e.target.value;
        let currentPrinter = { ...this.state.currentPrinter };
        currentPrinter = value;
        this.setState({ currentPrinter });
    }

    validateRequiredField = (e) => {
        const validation = { ...this.state.validation };
        if (e.target.value === '' && e.target.attributes.getNamedItem('required')) {
            const key = e.target.attributes.getNamedItem('object').value;
            const name = e.target.name;
            validation[key][name]['msg'] = strings.errorRequired;
            validation[key][name]['valid'] = false;
        }
        this.setState({ validation }, () => this.validateAllRequiredFields());
    }

    getSum = (total, num) => {
        return total + num;
    }

    validateAllRequiredFields = () => {
        const validation = { ...this.state.validation };
        let isReadyToSubmit = { ...this.state.isReadyToSubmit };
        let arrValidation = Object.keys(validation).map((k) => validation[k]);
        let i = arrValidation.map((i) => {
            return Object.keys(i).map((k) => i[k]);
        })
        .map((i) => {
            return i.filter((l) => {
                return typeof (l.valid) !== 'undefined';
            }).length;
        })
        .reduce(this.getSum);

        for (let type in validation) {
            for (let field in validation[type]) {
                if (validation[type][field]['valid']) {
                    i--;
                }
            }
        }
        isReadyToSubmit = (i === 0);
        this.setState({ isReadyToSubmit });
    }

    validate = Debounce((value, key, name, validationRegEx, e) => {
        const validation = { ...this.state.validation };
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value) && value !== '') {
            validation[key][name]['msg'] = strings.errorInvalid;
            isValid = false;
        }
        validation[key][name]['valid'] = isValid;
        this.setState({ validation }, () => { this.validateRequiredField(e) });
    }, 250);

    populateTicketSelection = (id, position = 0, type) => {
        let events;
        type === 'flexpass' ? events = [...this.state.flexpasses] : events = [...this.state.events];
        const isTicketsOpen = true;
        let ticketSelection = {};
        let max_seats = this.state.max_seats;
        events.forEach((event) => {
            if (event.id === parseInt(id, 0)) {
                ticketSelection = {
                    id: event.id,
                    name: event.name,
                    poster_graphic_url: event.poster_graphic_url,
                    artists: event.artists || [],
                    artistId: undefined,
                    date: event.event_dates && event.event_dates[position] ? event.event_dates[position].event_datetime_local : undefined,
                    event_date_id: event.event_dates && event.event_dates[position] ? event.event_dates[position].id : undefined,
                    dateIndex: position,
                    type: type === 'flexpass' ? 'flexpass' : event.venue.venue_type,
                    tickets: event.pricing_options,
                    zoom_level: event.venue ? event.venue.zoom_level : 40,
                    event_type: event.event_type
                }
                if(event.venue !== undefined){
                    max_seats = event.venue.max_seats;
                } else {
                    max_seats = event.max_purchases;
                }
            }
        });
        this.setState({
            ticketSelection,
            max_seats,
            isTicketsOpen,
            isReset: false,
        }, () => {
            // Accessibility - Set tabIndex attribute and focus
            setTimeout(() => {
                if (document.getElementById('ticket-button')) {
                    document.getElementById('ticket-button').setAttribute('tabIndex', 1);
                    document.getElementById('ticket-button').focus();
                }
            }, 500);
            this.refreshReservedSeating();
            window.scrollTo(0, 0);

            // VOD single ticket #1471
            // If event is VOD, and there's only one price, add one ticket automatically for patrons and direct the user to Billing
            /* let ticketSelection = this.state.ticketSelection;
            if (ticketSelection.event_type === 'Video On Demand' && !this.props.user.role) {
                let pricingOptions = this.state.ticketSelection;
                this.state.events.find(event => event.id === pricingOptions.id)
                    .event_dates.find(date => date.id === pricingOptions.event_date_id)
                        .section_pricing[0].options.map(option => {
                            pricingOptions.tickets.map(ticket => {
                                if (ticket.id === option.id) {
                                    ticket['value'] = option.value;
                                }
                            })
                        });
                let ticketsForPatrons = pricingOptions.tickets.filter((ticket) => ticket.value === 'all');
                if (ticketsForPatrons.length === 1) {
                    ticketSelection['tickets'].forEach((ticket, i) => {
                        if (ticket.id === ticketsForPatrons[0].id) {
                            ticketSelection['tickets'][i].quantity = 1;
                        }
                    });
                    this.setState({
                        ticketSelection,
                        isTicketsOpen: false,
                        isBillingOpen: true,
                    }, () => {
                        this.updateTicketsInCart(this.state.ticketSelection, this.state.ticketSelection.type);
                    });
                }
            } */
        });
    }

    refreshReservedSeating = () => {
        this.setState({ refresh: this.state.refresh + 1 });
    }

    clearTicketSelection = () => {
        const ticketSelection = {...this.state.ticketSelection};
        ticketSelection['tickets'].filter((ticket) => ticket.quantity).map((ticket) => ticket.quantity = '');
        this.setState({ ticketSelection });
    }

    toggleCustomerEditingMode = () => {
        let isCustomerEditingMode = { ...this.state.isCustomerEditingMode };
        isCustomerEditingMode = false;
        const customer = {...this.state.customer};
        const validation = { ...this.state.validation };
        for (let key in customer) {
            key === 'mailing_list' || key === 'email_list' ? customer[key] = true : customer[key] = '';
            if (key === 'address_1' || key === 'city' || key === 'zip' || key === 'phone' || key === 'email' || key === 'first_name' || key === 'last_name') {
                validation['customer'][key]['msg'] = strings.errorRequired;
                validation['customer'][key]['valid'] = false;
            }
        }
        this.setState({ 
            customer,
            validation,
            isCustomerEditingMode
        }, () => this.validateAllRequiredFields());
    }

    toggleDetails = (id, type) => {
        if(type === 'flexpass') {
            const flexpasses = [...this.state.flexpasses];
            flexpasses.filter(flexpass => flexpass.id === id).map(flexpass => {
                return flexpass.isDetailsOpen = !flexpass.isDetailsOpen;
            });
            this.setState({ flexpasses });
        } else {
            const events = [...this.state.events];
            events.filter(event => event.id === id).map(event => {
                return event.isDetailsOpen = !event.isDetailsOpen;
            });
            this.setState({ events });
        }
    }

    toggleDate = (id) => {
        const events = [...this.state.events];
        events.filter(event => event.id === id).map(event => {
            return event.isDateOpen = !event.isDateOpen;
        });
        this.setState({ events });
    }

    toggleAllDates = () => {
        const events = [...this.state.events];
        events.filter(event => event.isDateOpen === true).map(event => {
            return event.isDateOpen = false;
        });
        this.setState({ events });
    }

    toggleDateSettings = (id, position = null) => {
        const events = [...this.state.events];
        events.filter(event => event.id === id).forEach(event => {
            if (position !== null) {
                event.event_dates[position].isDateSettingsOpen = !event.event_dates[position].isDateSettingsOpen;
            }
            else {
                event.event_dates.forEach((date) => {
                    date.isDateSettingsOpen = false;
                })
            }
        });
        this.setState({ events });
    }

    toggleCategory = (category) => {
        const isCategoryOpen = { ...this.state.isCategoryOpen };
        isCategoryOpen[category] = !isCategoryOpen[category];
        this.setState({
            isCategoryOpen
        }, async () => {
            let existingEvents = this.state.events;
            let getCategoryEvents = true;

            // Check if events in that category have already been loaded
            existingEvents.forEach((event) => {
                if (event.status === category) {
                    getCategoryEvents = false;
                }
            });
            if (getCategoryEvents) {
                const responseEvents = await this.getClientEvents(this.state.client.id, this.props.user, category);
                console.log('Get Events Response: ', responseEvents.data.events);
                let events = [];
                events.push(...existingEvents, ...responseEvents.data.events)
                this.setState({
                    events,
                });
            }
        });
    }

    toggleAllCategories = () => {
        const isCategoryOpen = { ...this.state.isCategoryOpen };
        for (let category in isCategoryOpen) {
            isCategoryOpen[category] = false;
        }
        this.setState({ isCategoryOpen });
        this.setState({ isConfirmationOpen: false });
    }

    toggleBilling = (bool) => {
        let isBillingOpen = this.state.isBillingOpen;

        // Show Streaming Warning if Stream events (VOD, Scheduled Content or Live Stream)
        if (bool) {
            this.showStreamingWarning(bool);
        }
        if (isBillingOpen !== bool) {
            this.setState({ isBillingOpen : bool } , () => {
                if (this.state.isBillingOpen) {
                    setTimeout(() => {
                        document.getElementById('fees_and_discounts_donation').setAttribute('tabIndex', 1);
                        document.getElementById('fees_and_discounts_donation').focus();
                    }, 500);
                }
                if (this.state.isCustomerInfoOpen) {
                    if (document.getElementById('tickets')) {
                        document.getElementById('tickets').setAttribute('tabIndex', -1);
                        document.getElementById('tickets').focus();
                    }
                } else {
                    if (document.getElementById('tickets')) {
                        document.getElementById('tickets').removeAttribute('tabIndex');
                    }
                }
            });
        }
    }

    showStreamingWarning = (bool) => {
        const events = this.state.events;
        const cartPricing = this.state.cartPricing;
        const ticketSelection = this.state.ticketSelection;

        let hasVODEvent = false;
        let hasLiveStreamingEvent = false;
        let hasScheduledContentEvent = false;
        let selectedEvent = this.state.selectedEvent;
        let selectedDate = this.state.selectedDate;

        /* if (cartPricing.tickets.length > 0) {
            cartPricing.tickets.forEach((ticket) => {
                if (ticket.event.event_type === 'Video On Demand') {
                    hasVODEvent = true;
                }
                if (ticket.event.event_type === 'Live Stream') {
                    hasLiveStreamingEvent = true;
                }
                if (ticket.event.event_type === 'Scheduled Content') {
                    hasScheduledContentEvent = true;
                }
                events.forEach((event) => {
                    if (event.id === ticket.event.id) {
                        selectedEvent = event;
                        event.event_dates.forEach((date) => {
                            if (date.id === ticket.event_date_id) {
                                selectedDate = date;
                            }
                        })
                    } 
                });
            });
        } */
        if (ticketSelection.event_type !== ''){
            if (ticketSelection.event_type === 'Video On Demand') {
                hasVODEvent = true;
            }
            if (ticketSelection.event_type === 'Live Stream') {
                hasLiveStreamingEvent = true;
            }
            if (ticketSelection.event_type === 'Scheduled Content') {
                hasScheduledContentEvent = true;
            }

            events.forEach((event) => {
                if (event.id === ticketSelection.id) {
                    selectedEvent = event;
                    event.event_dates.forEach((date) => {
                        if (date.id === ticketSelection.event_date_id) {
                            selectedDate = date;
                        }
                    })
                } 
            });
        }
        

        if (!this.props.user.is_client) {
            if (bool && hasVODEvent) {
                this.setState({
                    isVODWarning: true,
                    selectedEvent,
                    selectedDate,
                })
            }
    
            if (bool && hasLiveStreamingEvent) {
                this.setState({
                    isLiveStreamingWarning: true,
                    selectedEvent,
                    selectedDate,
                })
            }
    
            if (bool && hasScheduledContentEvent) {
                this.setState({
                    isScheduledContentWarning: true,
                    selectedEvent,
                    selectedDate,
                })
            }
        }
    }

    toggleTickets = () => {
        let isTicketsOpen = this.state.isTicketsOpen;
        isTicketsOpen = !isTicketsOpen;
        this.setState({
            isTicketsOpen
        }, () => {
            // Accessibility - Remove tabIndex attribute if tickets are closed
            setTimeout(() => {
                if (!this.state.isTicketsOpen) {
                    document.getElementById('ticket-button').removeAttribute('tabIndex');
                } else {
                    document.getElementById('ticket-button').setAttribute('tabIndex', 1);
                    document.getElementById('ticket-button').focus();
                }
            }, 500);
            window.scrollTo(0, 0);
        });
    }

    toggleCustomerInfo = async (bool) => {
        let isCustomerInfoOpen = this.state.isCustomerInfoOpen;
        if (isCustomerInfoOpen !== bool) {
            this.setState({ isCustomerInfoOpen: bool }, () => {
                if (!this.state.isCustomerInfoOpen) {
                    document.getElementById('billing-info').setAttribute('tabIndex', -1);
                    document.getElementById('billing-info').focus();
                } else {
                    document.getElementById('billing-info').removeAttribute('tabIndex', -1);
                    if (document.getElementById('customer-info')) {
                        document.getElementById('customer-info').setAttribute('tabIndex', 1);
                        document.getElementById('customer-info').focus();
                    }
                }
            });
        }
        if (this.state.billing.method === 'reader') {
            this.sendCartToTerminal();
        }
    }

    sendCartToTerminal = async () => {
        if (this.state.isTerminalConnected) {
            // Set Reader Display
            let line_items = [];
            this.state.cartItems.forEach((cartItem) => {
                cartItem.forEach((item) => {
                    if (!item.social_distance) {
                        let new_line_item = {};
                        new_line_item.description = `${item.desc} (${item.name})`;
                        new_line_item.amount = item.amount * 100;
                        new_line_item.quantity = 1;
                        line_items.push(new_line_item);
                    }
                });
            });
        
            const setReaderDisplayResponse = await terminal.setReaderDisplay({
                type: 'cart',
                cart: {
                    line_items,
                    tax: 0,
                    total: this.state.cartPricing.txn_gross * 100,
                    currency: 'usd',
                },
            });
            console.log('==============setReaderDisplayResponse: ', setReaderDisplayResponse);
        }
    }

    updateCustomerFromAutocompleteInput = (customer, validation) => {
        this.setState({
            customer,
            validation
        }, () => this.validateAllRequiredFields());
    }

    toggleConfirmDeleteEvent = (e) => {
        this.setState({
            eventIdToDelete: e
        });
        this.setState({ 
            isDeleteEventOpen: !this.state.isDeleteEventOpen
        });
    }
    
    getClientEvents = async (clientId, user, status) => {
        let query;
        let limit = this.state.limit;
        let page = this.state.page;
        user.role ? query = `/events?status=${status}&limit=${limit[status]}&page=${page[status]}` : query = `/event-listing/${clientId}`;
        return await ApiRequest(query);
    }

    updateCategoryEvents = (category) => {
        const isCategoryOpen = { ...this.state.isCategoryOpen };
        if (isCategoryOpen['past']) {
            let allEvents = this.state.events;
            let previousPastEventsLength = this.state.previousPastEventsLength;
            let eventsToRemove = [];

            // Check if events in that category have already been loaded
            allEvents.forEach((event) => {
                if (event.status === category) {
                    eventsToRemove.push(event);
                }
            });
            console.log('---eventsToRemove', eventsToRemove);
            let eventsFiltered = allEvents.filter(x => !eventsToRemove.includes(x));
            console.log('---eventsFiltered', eventsFiltered);

            let limit = this.state.limit;
            if (eventsToRemove !== previousPastEventsLength) {
                limit[category] += 8;
            }
            
            this.setState({
                limit,
            }, async () => {
                
                const responseEvents = await this.getClientEvents(this.state.client.id, this.props.user, category);
                console.log('Get Events Response: ', responseEvents.data.events);
                let events = [];
                events.push(...eventsFiltered, ...responseEvents.data.events);
                console.log('events', events);
                this.setState({
                    events,
                    previousPastEventsLength: responseEvents.data.events.length,
                });
            });
        }
    }

    confirmConfirmDeleteEvent = async () => {
        this.setState({ 
            isDeleteEventOpen: !this.state.isDeleteEventOpen
        });

        this.setMessage('','','loading');
        try {
            const response = await deleteEvent(this.state.eventIdToDelete);
            console.log('Response: ', response);
            if(response.data.success){
                this.setMessage(window.general_strings.msg.yay, strings.msg.deleteEventSuccess,'success');
                setTimeout(() => {
                    this.setMessage('','','');
                }, 3000);

                const responseEvents = await this.getClientEvents(this.state.client.id, this.props.user, 'active');
                console.log('Get Events Response: ', responseEvents.data.events);
                this.setState({
                    events: responseEvents.data.events || [],
                });

            } else {
                this.setMessage(window.general_strings.msg.oops,response.data.error.code,'error');
                setTimeout(() => {
                    this.setMessage('','','');
                }, 3000);
            }
        } catch (error) {
            console.log(error);
        }
        
        async function deleteEvent(eventId) {
            return await ApiRequest(`/events/${eventId}`, {
                method: 'delete'
            });
        }
    }

    toggleConfirmDeleteFlexpass = (e) => {
        this.setState({
            flexpassIdToDelete: e
        });
        this.setState({ 
            isDeleteFlexpassOpen: !this.state.isDeleteFlexpassOpen
        });
    }

    confirmConfirmDeleteFlexpass = async () => {
        this.setState({ 
            isDeleteFlexpassOpen: !this.state.isDeleteFlexpassOpen
        });

        this.setMessage('','','loading');
        try {
            const response = await deleteFlexpass(this.state.flexpassIdToDelete);
            console.log('Response: ', response);
            if(response.data.success){
                this.setMessage(window.general_strings.msg.yay, strings.msg.deleteEventSuccess,'success');
                setTimeout(() => {
                    this.setMessage('','','');
                }, 3000);

                const responseFlexpasses = await getClientFlexpasses(this.state.client.id, this.props.user);
                console.log('Get Flexpasses Response: ', responseFlexpasses.data.flexpasses);
                this.setState({
                    flexpasses: responseFlexpasses.data.flexpasses || [],
                });
            } else {
                this.setMessage(window.general_strings.msg.oops,response.data.error.code,'error');
                setTimeout(() => {
                    this.setMessage('','','');
                }, 3000);
            }
        } catch (error) {
            console.log(error);
        }
        
        async function deleteFlexpass(flexpassId) {
            return await ApiRequest(`/flexpass/${flexpassId}`, {
                method: 'PUT',
                data: {
                    sale_end: moment.utc().add(-1, 'days').toDate(),
                    sale_end_box_office: moment.utc().add(-1, 'days').toDate()
                }
            });
        }

        async function getClientFlexpasses(clientId = '') {
            return await ApiRequest(`/flexpass-listing/${clientId}`);
        }
    }

    toggleConfirmEarlyPayout = (id) => {
        let eventId = (id === parseInt(id, 10)) ? id : undefined;
        this.setState({
            eventIdToEarlyPayout: eventId,
            showEarlyPayoutConfirmation: false,
            isEarlyPayoutOpen: !this.state.isEarlyPayoutOpen
        });
    }

    confirmConfirmEarlyPayout = async () => {
        this.setState({ 
            isEarlyPayoutOpen: this.state.isEarlyPayoutOpen
        });

        this.setMessage('','','loading');
        try {
            const response = await earlyPayout(this.state.eventIdToEarlyPayout);
            console.log('Response: ', response);

            if(response.data.success){
                this.setState({ 
                    isEarlyPayoutOpen: true,
                    showEarlyPayoutConfirmation: true
                });
                this.setMessage('','','');
            } else {
                this.setState({ 
                    isEarlyPayoutOpen: false,
                    showEarlyPayoutConfirmation: false
                });

                this.setMessage(window.general_strings.msg.oops, response.data.error.code,'error');
                setTimeout(() => {
                    this.setMessage('','','');
                }, 3000);
            }
        } catch (error) {
            console.log(error);
        }
        
        async function earlyPayout(eventId) {
            return await ApiRequest(`/events/${eventId}/early-payout`, {
                method: 'POST'
            });
        }
    }

    getAccountEventReport = async (e, ticketType) => {
        const routePath = (ticketType && ticketType === 'flexpass') ? 'flexpass-account/pdf?flexpass_id=' : 'event-account/pdf?event_id=';
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/${routePath}${e}`);
    }

    getStreamAccessReport = async (e, ticketType) => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/stream-code/csv?event_id=${e}`);
    }

    getTicketPriceSummary = async (e) => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/ticket-breakdown-summary/csv?event_id=${e}`);
    }

    getTicketBreakdown = async (e) => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/ticket-breakdown/csv?event_id=${e}`);
    }

    getArtistCreditReport = async (e) => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/artist-credit-report/csv?event_id=${e}`);
    }

    getQuestionTagReport = async (e) => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/question-report/csv?event_id=${e}`);
    }

    getVenueSeatLabel = async (e) => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/venue-seat-labels/pdf?venue_id=${e}`);
    }

    getSeatingReport = async (e) => {
        window.open(`${process.env.REACT_APP_SHOWTIX4U_API_HOST}/reports/event-seating/pdf?event_date_id=${e}`);
    }

    getHouseCount = async (e) => {
        this.setMessage('','','loading');
        try {
            const response = await getHouseCount(e);
            console.log('Response: ', response);
            if(response.data){
                this.setMessage('','','');
                const events = [...this.state.events];
                
                let eventId = 0;
                let dateId = 0;
                events.forEach((event) => {
                    event.event_dates.forEach((date) => {
                        if(parseInt(date.id) === parseInt(e)){
                            eventId = event.id;
                            dateId = date.id;
                        }
                    })
                });
                const indexEvent = events.findIndex(event => {
                    return parseInt(event.id, 0) === eventId;
                });
                const indexDate = events[indexEvent].event_dates.findIndex(date => {
                    return parseInt(date.id, 0) === dateId;
                });
                events[indexEvent].event_dates[indexDate]['held_count'] = response.data.held_count;
                events[indexEvent].event_dates[indexDate]['sold_count'] = response.data.sold_count;
                events[indexEvent].event_dates[indexDate]['total_count'] = response.data.total_count;
                this.setState({ events });
            } else {
                this.setMessage(window.general_strings.msg.oops,response.data.error.code,'error');
                setTimeout(() => {
                    this.setMessage('','','');
                }, 3000);
            }
        } catch (error) {
            console.log(error);
        }
        
        async function getHouseCount(dateId) {
            return await ApiRequest(`/event-dates/${dateId}/house-count`, {
                method: 'get'
            });
        }
    }

    detectDymoPrinter = async () => {
        try {
            let dymo = new Dymo();
            const responsePrinters = await dymo.getPrinters();
            console.log('Get Dymo Printers: ', responsePrinters);
            if (responsePrinters) {
                let printers = responsePrinters || [];
                console.log(printers);
                this.setState({
                    printers,
                    currentPrinter: printers[0]
                })
            }
        } catch (error) {
            console.log(error, 'Dymo Printer', 'Trying alternative method...');
            try {
                let dymo = new Dymo({ hostname: '127.0.0.1' });
                const responsePrinters = await dymo.getPrinters();
                console.log('Get Dymo Printers: ', responsePrinters);
                if (responsePrinters) {
                    let printers = responsePrinters || [];
                    console.log(printers);
                    this.setState({
                        printers,
                        currentPrinter: printers[0]
                    })
                }
            } catch (error) {
                console.log(error, 'Dymo Printer', 'Failure.');
            }
        }
    }

    detectBocaPrinter = () => {
        let currentPrinterBoca = localStorage.getItem('defaultBocaPrinter') ? localStorage.getItem('defaultBocaPrinter') : '';
        this.setState({
            currentPrinterBoca,
        });
        try {
            let boca = new Boca();
            boca.getJSPrintManager();
            boca.getBocaPrinters().then((responsePrinters) => {
                if (responsePrinters) {
                    console.log("has boca printer");
                    let bocaPrinters = responsePrinters.filter((printer) => printer.name.toLowerCase().includes('boca'));
                    let starPrintersUSB = responsePrinters.filter((printer) => printer.name.toLowerCase().includes('star'));
                    this.setState({
                        printersBoca: bocaPrinters,
                        printersStarUSB: starPrintersUSB,
                    });

                    // save also in baseState object
                    this.baseState.printersBoca = responsePrinters.filter((printer) => printer.name.toLowerCase().includes('boca'));
                    this.baseState.currentPrinterBoca = currentPrinterBoca;
                }
            },(error) => {
                console.log("no boca printer");
            });
        } catch (error) {
            console.log(error, 'Boca Printer', 'Failure.');
        }
    };

    handlePrinterChangeBoca = (e) => {
        let value = e.target.value;
        let currentPrinterBoca = { ...this.state.currentPrinterBoca };
        currentPrinterBoca = value;
        this.setState({ currentPrinterBoca });
        localStorage.setItem('defaultBocaPrinter', currentPrinterBoca);
    }

    detectStarPrinter = async () => {
        let currentPrinterStar = localStorage.getItem('defaultStarPrinter') ? localStorage.getItem('defaultStarPrinter') : '';
        this.setState({
            currentPrinterStar,
        });
        let printersStar = this.state.printersStar;
        //let printersStarUSB = this.state.printersStarUSB;
        try {
            /* let star = new Star();
            star.getStarPrinters2().then((responsePrinters) => {
                console.log('responsePrinters', responsePrinters)
                if (responsePrinters) {
                    printersStarUSB = responsePrinters;
                    this.setState({
                        printersStarUSB,
                    });
                }
            },(error) => {
                console.log("no boca printer");
            }); */

            const getPrintersResponse = await getStarPrinters();
            console.log('getPrintersResponse', getPrintersResponse);
            if (getPrintersResponse.data.printers) {
                console.log('PRINTER STAR', getPrintersResponse.data.printers)
                printersStar = getPrintersResponse.data.printers;
                this.setState({
                    printersStar,
                });
            }
        } catch (error) {
            console.log(error);
        }

        async function getStarPrinters() {
            return await ApiRequest(`/printers`, {
                method: 'GET',
            });
        }
    };

    handlePrinterChangeStar = (e) => {
        let value = e.target.value;
        let currentPrinterStar = { ...this.state.currentPrinterStar };
        currentPrinterStar = value;
        this.setState({ currentPrinterStar });
        localStorage.setItem('defaultStarPrinter', currentPrinterStar);
    };

    getUserIP = () => {
        if(this.state.ip === undefined){
            fetch('https://api.ipify.org?format=json')
                .then(response => response.json())
                .then(data => {
                    this.setState({ ip:data.ip })
                });
        }
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    resetFeesAndDiscounts = (isResetDonationAndCoupon) => {
        let fees_and_discounts = {};
        if (isResetDonationAndCoupon) {
            fees_and_discounts = {
                donation: 0,
                couponFlexpass: '',
                validCoupon: null,
                flexpass: {
                    code: '',
                    amount: 0,
                    validFlexpass: null
                },
                shipping: !this.props.user.role ? 'print' : 'print'
            };
        } else {
            fees_and_discounts = {
                donation: this.state.fees_and_discounts.donation,
                couponFlexpass: this.state.fees_and_discounts.couponFlexpass,
                validCoupon: this.state.fees_and_discounts.validCoupon,
                flexpass: {
                    code: '',
                    amount: 0,
                    validFlexpass: null
                },
                shipping: !this.props.user.role ? 'print' : 'print'
            };
        }
        
        this.setState({ fees_and_discounts });
    }

    setCallCenterFees = (e) => {
        let value = e.target.value;
        if (e.target.type === "radio") {
            (value === "true") ? value = true : value = false;
        }
        this.setState({ call_center_fee: value }, async () => {
            try {
                const cartPricingResponse = await this.getCartPricing(this.props.user);
                console.log('Cart pricing: ', cartPricingResponse);
            } catch (error) {
                console.log(error);
            }
        });
    }

    handleServiceFee = (e) => {
        let value = e.target.value;
        this.setState({ service_fee: value }, async () => {
            try {
                const cartPricingResponse = await this.getCartPricing(this.props.user);
                console.log('Cart pricing: ', cartPricingResponse);
            } catch (error) {
                console.log(error);
            }
        });
    }

    handleShippingFee = (type = null, e) => {
        let value;
        type !== null ? value = type : value = e.target.value;
        const fees_and_discounts = { ...this.state.fees_and_discounts }
        fees_and_discounts['shipping'] = value;
        const customer = { ...this.state.customer };
        this.setState({ 
            fees_and_discounts,
            customer
        }, async () => {
            try {
                const cartPricingResponse = await this.getCartPricing(this.props.user);
                console.log('Cart pricing: ', cartPricingResponse);
            } catch (error) {
                console.log(error);
            }
        });
    }

    handleFlexpassAmount = (e) => {
        const value = e.target.value;
        const name = e.target.name;
        const key = e.target.attributes.getNamedItem('object').value;
        const fees_and_discounts = { ...this.state.fees_and_discounts };
        fees_and_discounts[name][key] = value;
        this.setState({ fees_and_discounts });
    }

    handleDonationCouponsAndFlexpass = (e) => {
        let value = e.target.value;
        let name = e.target.name;
        const fees_and_discounts = { ...this.state.fees_and_discounts };
        if (name === 'donation') {
            fees_and_discounts[name] = value > 0 ? value : 0;
        } else {
            fees_and_discounts[name] = value;
        }
        this.setState({ fees_and_discounts });
    }

    applyDonation = async () => {
        const cartPricingResponse = await this.getCartPricing(this.props.user);
        console.log('Cart pricing: ', cartPricingResponse);
        this.setState({
            cartPricing: cartPricingResponse.data
        });
    }

    applyCoupon = async () => {
        await this.sanitizeCouponFlexpassCode();

        try {
            const code = this.state.fees_and_discounts.couponFlexpass;
            const couponsResponse = await validateCoupons(code);
            console.log('Coupons Response: ', couponsResponse);

            const fees_and_discounts = { ...this.state.fees_and_discounts };
            if (couponsResponse.data && couponsResponse.data.is_valid) {
                fees_and_discounts['tickets_remaining'] = couponsResponse.data.tickets_remaining;
                if (couponsResponse.data.coupon_id) {
                    fees_and_discounts['validCoupon'] = fees_and_discounts['couponFlexpass'];
                    fees_and_discounts['couponFlexpass'] = '';
                    this.setState({ fees_and_discounts }, async () => {
                        const cartPricingResponse = await this.getCartPricing(this.props.user);
                        console.log('Cart pricing: ', cartPricingResponse);
                        this.setState({
                            cartPricing: cartPricingResponse.data
                        });
                    });
                } else {
                    const codeFlexpass = fees_and_discounts['couponFlexpass'];
                    const flexpassDetails = this.state.flexpassDetails;
                    fees_and_discounts['flexpass']['validFlexpass'] = codeFlexpass;
                    fees_and_discounts['couponFlexpass'] = '';
                    this.setState({ fees_and_discounts });

                    
                    if (codeFlexpass.toLowerCase().startsWith("f-")) {
                        const allEvents = this.state.allEvents;
                        flexpassDetails['name'] = couponsResponse.data.flexpass_name;
                        flexpassDetails['description'] = couponsResponse.data.flexpass_desc;
                        flexpassDetails['tickets_used'] = couponsResponse.data.tickets_used;
                        flexpassDetails['max_tickets'] = couponsResponse.data.max_tickets;
                        flexpassDetails['tickets_remaining'] = couponsResponse.data.tickets_remaining;
                        flexpassDetails['events'] = [];
                        couponsResponse.data.event_date_ids.forEach((event_date_id) => {
                            allEvents.forEach((event) => {
                                if (parseInt(event.id, 10) === parseInt(event_date_id, 10)) {
                                    flexpassDetails['events'].push(event);
                                }
                            });
                        });
                        this.setState({ flexpassDetails });
                        
                        this.toggleFlexpassDetailsModal();
                    }
                }
            } else {
                fees_and_discounts['couponFlexpass'] = '';
                this.setState({ fees_and_discounts });
                window.scrollTo(0, 0);
                this.setMessage(window.general_strings.msg.oops, `${strings[couponsResponse.data.reason]}`, 'error');
                setTimeout(() => {
                    this.setMessage('', '', '');
                }, 3000);
            }
        } catch (error) {
            window.scrollTo(0, 0);
            this.setMessage(window.general_strings.msg.oops, error, 'error');
            setTimeout(() => {
                this.setMessage('', '', '');
            }, 3000);
        }

        async function validateCoupons(code) {
            console.log(code);
            let query;
            if (code.charAt(0).toLowerCase() === 'c') {
                query = `/coupons/validate`;
            } else if (code.charAt(0).toLowerCase() === 'f') {
                query = `/flexpass/validate`;
            } else {
                throw new Error(strings.errorInvalid);
            }
            return await ApiRequest(query, {
                method: 'post',
                data: {
                    code
                }
            });
        }
    }

    sanitizeCouponFlexpassCode = () => {
        const fees_and_discounts = { ...this.state.fees_and_discounts };
        const code = fees_and_discounts['couponFlexpass'];
        const isValidCouponFlexpass = code.toLowerCase().startsWith("c-") || code.toLowerCase().startsWith("f-");
        if (!isValidCouponFlexpass && code != '') {
            fees_and_discounts['couponFlexpass'] = "C-" + code;
            this.setState({ fees_and_discounts });
        }
    }

    getAllEventsList = () => {
        (async () => {
            try {
                const eventsListResponse = await eventsList();
                console.log('events list response: ', eventsListResponse);

                if(eventsListResponse.data.event_dates){
                    this.setMessage('','','');
                    
                    let allEvents = eventsListResponse.data.event_dates.map(e => {
                        return {
                            id: e.event_date_id,
                            name: e.event_name,
                            date: e.event_datetime_local,
                        }
                    });

                    this.setState({ 
                        allEvents,
                    });
                } else {
                    this.setMessage(window.general_strings.msg.oops, eventsListResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function eventsList() {
            return await ApiRequest('/event-dates', {
                method: 'GET'
            });
        }
    }

    removeCoupon = () => {
        const fees_and_discounts = { ...this.state.fees_and_discounts };
        fees_and_discounts['validCoupon'] = null;
        this.setState({ fees_and_discounts }, async () => {
            const cartPricingResponse = await this.getCartPricing(this.props.user);
            this.setState({
                cartPricing: cartPricingResponse.data
            });
        });
    }
    
    removeFlexpass = () => {
        const fees_and_discounts = { ...this.state.fees_and_discounts };
        fees_and_discounts['flexpass']['validFlexpass'] = null;
        this.setState({ fees_and_discounts }, async () => {
            const cartPricingResponse = await this.getCartPricing(this.props.user);
            this.setState({
                cartPricing: cartPricingResponse.data
            });
        });
    }

    clearDonationFromCart = () => {
        const fees_and_discounts = { ...this.state.fees_and_discounts };
        fees_and_discounts['donation'] = 0;
        this.setState({ fees_and_discounts }, async () => {
            const cartPricingResponse = await this.getCartPricing(this.props.user);
            this.setState({
                cartPricing: cartPricingResponse.data
            });
        });
    }

    rebuildCartItems = (response) => {
        const cartItems = [];
        const tickets = response.data.tickets;
        console.log('tickets', tickets)
        const flexpasses = response.data.flexpasses;
        flexpasses.map(flexpass => flexpass['type'] = 'flexpass');
        
        const groupedTickets = GroupBy(tickets, 'event_date_id');
        const groupedFlexpasses = GroupBy(flexpasses, 'flexpass_id');

        for (let group in groupedTickets) {
            cartItems.push(groupedTickets[group].sort((a, b) => (a.pricing_option_id > b.pricing_option_id) ? 1 : ((b.pricing_option_id > a.pricing_option_id) ? -1 : 0)));
        }

        for (let group in groupedFlexpasses) {
            cartItems.push(groupedFlexpasses[group].sort((a, b) => (a.price > b.price) ? 1 : ((b.price > a.price) ? -1 : 0)));
        }

        cartItems.forEach(cartItem => {
                cartItem.map(ticket => {
                    // Flex Pass Cart (#1163)
                    if(ticket.flexpass_id) {
                        this.state.flexpasses.map((flexpass) => {
                            if (flexpass.id === ticket.flexpass_id) {
                                ticket['name'] = flexpass.name;
                                ticket['amount'] = ticket.price;
                                ticket['poster_graphic_url'] = flexpass.poster_graphic_url || null;
                                flexpass.pricing_options.map((pricing_option) => {
                                    if (pricing_option.amount === ticket.price) {
                                        ticket['desc'] = pricing_option.desc;
                                    }
                                });
                            }
                        });
                    } else {
                        this.state.events.map(event => event.pricing_options.map((option) => {
                            if (option.id === ticket.pricing_option_id) {
                                ticket['desc'] = option.desc;
                                ticket['amount'] = option.amount;
                                ticket['poster_graphic_url'] = event.poster_graphic_url || null;
                                ticket['name'] = event.name;
                                ticket['type'] = event.venue.venue_type;
                                //ticket['social_distance'] = option.social_distance;
                            }
                        }));
                    }
                })

                cartItem.map(ticket => this.state.events.map(event => event.event_dates.map((date) => {
                    if (date.id === ticket.event_date_id) {
                        ticket['event_datetime'] = date.event_datetime;
                        ticket['event_datetime_local'] = date.event_datetime_local;
                    }
                })));
        });
        return cartItems;
    }

    getTicketsInCart = async (user) => {
        let query;
        let data = {};
        data['client_id'] = this.state.client.id;
        user.role ? query = `/box-office/cart` : query = `/tickets/cart`;
        try {
            const cart = await ApiRequest(query + `?client_id=${this.state.client.id}`);
            console.log('======================Get Cart Response: ', cart);
            if (cart.data.error) {
                throw new Error('Cart Error');
            } else {
                const cartItems = this.rebuildCartItems(cart);
                this.setState({
                    cartItems
                });
                this.props.getTotalTicketsForHeader(user, cart);
                return cartItems;
            }
        } catch (error) {
            console.log(error);
        }
    }

    getCartPricing = async (user, type) => {
        let query;
        user.role ? query = `/box-office/cart/pricing` : query = `/tickets/cart/pricing`;
        let data = {};
        data['call_center_fee'] = this.state.call_center_fee;
        data['service_fee'] = this.state.service_fee !== 'default' ? this.state.service_fee : undefined;
        data['donation'] = parseFloat(this.state.fees_and_discounts.donation);
        data['shipping_method'] = this.state.fees_and_discounts.shipping;
        data['type'] = type ? type : this.state.billing.method === 'check' ? 'cash' : this.state.billing.method;
        if (this.state.fees_and_discounts.validCoupon) {
            data['coupon_redemption'] = {};
            data['coupon_redemption']['code'] = this.state.fees_and_discounts.validCoupon;
        }
        if (this.state.fees_and_discounts.flexpass.validFlexpass) {
            data['flexpass_redemption'] = {};
            data['flexpass_redemption']['code'] = this.state.fees_and_discounts.flexpass.validFlexpass;
            data['flexpass_redemption']['amount'] = parseFloat(this.state.fees_and_discounts.flexpass.amount);
        }
        try {
            const cartPricing = await ApiRequest(query, {
                method: 'POST',
                data
            });
            console.log('cartPricing', cartPricing)
            this.setState({
                cartPricing: cartPricing.data,
                isFlexpassDetailsModalOpen: false,
            });

            if (this.state.billing.method === 'reader') {
                this.sendCartToTerminal();
            }
            return cartPricing
        } catch (error) {
            console.log(error);
        }
    }

    postReservedAdmissionTickets = async (user, ticketSelection, ticket_id, isQuickSelect) => {
        let query;
        user.role ? query = `/box-office/hold/reserved` : query = `/tickets/hold/reserved`;
        let data = {};
        data['event_date_id'] = ticketSelection.event_date_id;
        data['section_id'] = ticketSelection.section_id;
        data['row_id'] = ticketSelection.row_id;
        data['seat_id'] = ticketSelection.seat_id;
        data['presale_password'] = this.state.password || '';
        
        ticketSelection.pricing_option_id ? data['pricing_option_id'] = ticketSelection.pricing_option_id : false;
        if (!isQuickSelect) {
            ticket_id ? data['id'] = ticket_id : false;
        }
        console.log('data', data)

        return await ApiRequest(query, {
            method: 'POST',
            data
        });
    }

    disableCheckoutButton = (bool) => {
        let isCheckoutDisabled = {...this.state.isCheckoutDisabled}
        isCheckoutDisabled = bool;
        this.setState({ isCheckoutDisabled });
    }

    updateTicketsInCart = async (event, type, ticket_id = null, isSocialDistance, isQuickSelect) => {
        this.disableCheckoutButton(true);

        let _this = this;

        const ticketSelection = DeepCopy(event);
        if (isSocialDistance) {
            let cartItems = this.state.cartItems;
            cartItems[0].forEach((cartItem) => {
                if (parseInt(cartItem.seat_id, 10) === parseInt(ticketSelection.seat_id, 10)) {
                    ticket_id = cartItem.id;
                }
            });
        }
        
        console.log('ticketSelection', ticketSelection);

        if (this.props.user.role) {
            this.props.startClientTimer(this.state.cartItems);
        }

        console.log('event', event);
        console.log('type', type);
        console.log('ticket_id', ticket_id);

        try {
            let holdTicketsResponse;
            switch (type) {
                case 'general-admission':
                    holdTicketsResponse = await postGeneralAdmissionTickets(this.props.user, this.state.password);
                    break;
                case 'reserved':
                    holdTicketsResponse = await this.postReservedAdmissionTickets(this.props.user, ticketSelection, ticket_id, isQuickSelect);
                    break;
                case 'flexpass':
                    holdTicketsResponse = await postFlexpassTickets(this.props.user);
                    break;
                default:
                    holdTicketsResponse = await postGeneralAdmissionTickets(this.props.user, this.state.password);
            }
            console.log('Post Hold Ticket: ', holdTicketsResponse);

            document.getElementById('message-aria').innerText = `Ticket(s) have been added successfully to your cart.`;
            setTimeout(() => {
                document.getElementById('message-aria').innerText = ``;
            }, 3000);

            const isIterable = holdTicketsResponse != null && typeof holdTicketsResponse[Symbol.iterator] === 'function';
            // if holdTicketsResponse is an iterable and none of its iterations results in an error
            if ((isIterable && !holdTicketsResponse.some(ticket => ticket.data.error))
                // or if holdTicketsResponse is not an iterable and it does not contain an error
                || (holdTicketsResponse.data && !holdTicketsResponse.data.error)) {

                const ticketsInCartResponse = await this.getTicketsInCart(this.props.user);
                console.log('Tickets in cart: ', ticketsInCartResponse);

                const cartPricingResponse = await this.getCartPricing(this.props.user);
                console.log('Cart pricing: ', cartPricingResponse);

            } else {
                // if holdTicketsResponse is an iterable find its first error message
                let errorMessage;
                if(isIterable) {
                    errorMessage = holdTicketsResponse.find(ticket => ticket.data.error.code).data.error.code;
                } else {
                    errorMessage = holdTicketsResponse.data.error.code.split('-').join(' ');
                }
                this.setMessage(window.general_strings.msg.oops, errorMessage, 'error');
                setTimeout(() => {
                    this.setMessage('', '', '');
                }, 3000);
            }
        } catch (error) {
            console.log(error);
        }

        this.disableCheckoutButton(false);

        async function postFlexpassTickets(user) {
            let requests = [];
            let query;
            user.role ? query = `/box-office/flexpass/hold` : query = `/flexpass/hold`;
            for (const ticket of ticketSelection.tickets) {
                if (ticket.quantity > 0) {
                    const request = await ApiRequest(query, {
                        method: 'POST',
                        data: {
                            flexpass_id: ticketSelection.id,
                            price: ticket.amount,
                            count: ticket.quantity
                        }
                    });
                    requests.push(request);
                }
            }
            return requests;
        }

        async function postGeneralAdmissionTickets(user, password) {
            let requests = [];
            let query;
            user.role ? query = `/box-office/hold/general-admission` : query = `/tickets/hold/general-admission`;
            for (const ticket of ticketSelection.tickets) {
                if (ticket.quantity > 0) {
                    const request = await ApiRequest(query, {
                        method: 'POST',
                        data: {
                            event_date_id: ticketSelection.event_date_id,
                            pricing_option_id: ticket.id,
                            ticket_count: ticket.quantity,
                            presale_password: _this.state.password || ''
                        }
                    });
                    requests.push(request);
                }
            } 
            return requests;
        }

    }

    deleteFromCart = async (ticket) => {
        console.log(ticket);
        try {
            const releaseResponse = await releaseFromCart(this.props.user);
            console.log('Release ticket: ', releaseResponse);

            const ticketsInCartResponse = await this.getTicketsInCart(this.props.user);
            console.log('Tickets in cart: ', ticketsInCartResponse);

            const cartPricingResponse = await this.getCartPricing(this.props.user);
            console.log('Cart pricing: ', cartPricingResponse);

            document.getElementById('message-aria').innerText = `Ticket for ${ticket.name} has been removed successfully from cart.`;
            setTimeout(() => {
                document.getElementById('message-aria').innerText = ``;
            }, 3000);

        } catch (error) {
            console.log(error);
        }

        async function releaseFromCart(user) {
            let query;
            if(ticket.type === 'flexpass') {
                user.role ? query = `/box-office/flexpass/release/${ticket.held_flexpass_id}` : query = `/flexpass/release/${ticket.held_flexpass_id}`;
            } else {
                user.role ? query = `/box-office/cart/${ticket.id}` : query = `/tickets/cart/${ticket.id}`;
            }
            return await ApiRequest(query, {
                method: 'DELETE'
            });
        }
    }

    emptyCart = async () => {
        try {
            console.log('empty cart');
            const releaseAllResponse = await releaseTickets(this.props.user);
            console.log('Release all tickets from cart: ', releaseAllResponse);

            const ticketsInCartResponse = await this.getTicketsInCart(this.props.user);
            console.log('Tickets in cart: ', ticketsInCartResponse);

            const cartPricingResponse = await this.getCartPricing(this.props.user);
            console.log('Cart pricing: ', cartPricingResponse);

        } catch (error) {
            console.log(error);
        }

        async function releaseTickets(user) {
            let query;
            user.role ? query = `/box-office/cart` : query = `/tickets/cart`;
            return await ApiRequest(query, {
                method: 'DELETE'
            });
        }
    }

    toggleTimerUp = async () => {
        if(!this.state.checkoutInProgress) {
            await this.emptyCart();
            this.setState({ isTimerUpOpen: !this.state.isTimerUpOpen }, () => {
                if (this.state.isTimerUpOpen === false) {
                    this.resetTimer();
                }
            });
        }
    }

    toggleNoTickets = (show) => {
        if(show && show === true) {
            this.setState({isNoTicketsOpen:true});
        } else {
            this.setState({isNoTicketsOpen:!this.state.isNoTicketsOpen});
        }
    }

    resetTimer = async () => {
        if (this.state.isTerminalConnected) {
            if (this.state.checkoutInProgress) {
                await terminal.cancelCollectPaymentMethod();
            }
            await terminal.clearReaderDisplay();
        }
        window.location.reload();
    }

    togglePassword = (e) => {
        // open
        if(e !== undefined && e !== 'close'){
            let triggerFromUrl = e.hasOwnProperty('triggerFromUrl');
            this.setState({
                isPasswordOpen: true,
                isPasswordOpenFromUrl: triggerFromUrl
            });

            let eventId;
            let dateId;
            if(triggerFromUrl) {
                var eventId = e.event_id;
                var dateId = e.date_id;
            } else {
                if (e.target.attributes.getNamedItem('event_id')) {
                    eventId = e.target.attributes.getNamedItem('event_id').value;
                }
                if (e.target.attributes.getNamedItem('date_id')) {
                    dateId = e.target.attributes.getNamedItem('date_id').value;
                }
            }
            var hasValidFlexpassId = (!triggerFromUrl) ? e.target.attributes.getNamedItem('flexpass_id') !== null : false;
            let hasValidEventDateIds = eventId !== null && dateId !== null;

            if(hasValidEventDateIds){
                this.setState({ 
                    eventPasswordId: parseInt(eventId),
                    datePasswordId: parseInt(dateId),
                    flexpassPasswordId: undefined
                });
            }
            if(hasValidFlexpassId){
                this.setState({ 
                    flexpassPasswordId: parseInt(e.target.attributes.getNamedItem('flexpass_id').value),
                    eventPasswordId: undefined,
                    datePasswordId: undefined
                });
            }
        }
        // close
        else {
            this.setState({
                isPasswordOpen: false,
                isPasswordOpenFromUrl: false
            });
        }
    }

    checkPresalePassword = (password, isPasswordOpenFromUrl) => {
        if(this.state.eventPasswordId !== undefined){
            const events = [...this.state.events];
            const event_index = events.findIndex((event) => parseInt(event.id) === this.state.eventPasswordId);
            const date_index = events[event_index].event_dates.findIndex((date) => parseInt(date.id) === this.state.datePasswordId);
            if(password === events[event_index].event_dates[date_index].presale_password){
                events[event_index].event_dates[date_index].is_unlocked = true;
                this.setState({
                    events,
                    password
                });

                if(isPasswordOpenFromUrl) {
                    this.populatePreselectedDate(true);
                }
            } else {
                alert('Wrong password!');
            }
        }
        if(this.state.flexpassPasswordId !== undefined){
            const flexpasses = [...this.state.flexpasses];
            const flexpass_index = flexpasses.findIndex((flexpass) => parseInt(flexpass.id) === this.state.flexpassPasswordId);
            if(password === flexpasses[flexpass_index].presale_password){
                flexpasses[flexpass_index].is_unlocked = true;
                this.setState({flexpasses});
            }
        }
    }

    openDonationBilling = () => {
        const isCategoryOpen = {...this.state.isCategoryOpen};
        isCategoryOpen['active'] = false;
        isCategoryOpen['past'] = false;
        isCategoryOpen['pending'] = false;
        this.setState({
            isBillingOpen: true,
            isCategoryOpen
        }, () => {
            // Focus on the input Donation
            let input = document.getElementById('fees_and_discounts_donation');
            if (input) {
                input.focus();
            }
        });

    }

    getCurrentClient = async (clientId = '') => {
        let query;
        if (this.props.user.role) {
            query = '/clients/current';
        } else if (/^\d+$/.test(clientId)) {
            query = `/clients/${clientId}`;
        } else {
            query = `/clients/url-short-name/${clientId}`;
        }
        return await ApiRequest(query);
    } 

    setEarlyPayoutToActiveStatus = (events) => {
        return events.map(event => {
            if(event.status === 'early-payout') {
                event['status'] = 'active';
            }
            return event;
        });
    }

    toggleWidgetModal = (event) => {
        this.setState({
            isToggleWidgetModalOpen: !this.state.isToggleWidgetModalOpen
        });
        if(event) {
            this.setState({
                widgetModalEventID: event.id,
                widgetModalEventName: event.name
            });
        }
    };

    toggleStreamingWarningModal = (type: string) => {
        if (type === 'vod') {
            this.setState({
                isVODWarning: false,
                isBillingOpen: true,
            });
        }
        if (type === 'scheduled') {
            this.setState({
                isScheduledContentWarning: false,
                isBillingOpen: true,
            });
        }
        if (type === 'live') {
            this.setState({
                isLiveStreamingWarning: false,
                isBillingOpen: true,
            });
        }
    }

    toggleBrowserNotSupportedModal = () => {
        this.setState({
            isBrowserNotSupportedModalOpen: !this.state.isBrowserNotSupportedModalOpen
        });
    };

    toggleStripeDeviceModal = async (selectedDevice) => {
        let isStripeDeviceSelectOpen = this.state.isStripeDeviceSelectOpen;
        isStripeDeviceSelectOpen = !isStripeDeviceSelectOpen;
        this.setState({
            isStripeDeviceSelectOpen,
        });
        if (selectedDevice) {
            this.setMessage('', '', 'loading');
            this.connectToDevice(selectedDevice);
        }
    }

    toggleFlexpassDetailsModal = () => {
        let isFlexpassDetailsModalOpen = this.state.isFlexpassDetailsModalOpen;
        isFlexpassDetailsModalOpen = !isFlexpassDetailsModalOpen;
        this.setState({
            isFlexpassDetailsModalOpen,
        });
    }

    saveZoomLevel = async (zoom) => {
        const eventId = this.state.ticketSelection.id;
        const events = this.state.events;
        let venue = {};
        let event = {};
        events.forEach((_event) => {
            if (_event.id === eventId) {
                event = _event;
            }
        })
        event.client_id = undefined;
        event.venue_id = undefined;
        event.status     = undefined;
        event.upcoming_rank = undefined;
        event.isDateOpen = undefined;
        event.isDetailsOpen = undefined;
        event.poster_graphic_url = undefined;
        event.ad_graphic_url = undefined;
        event.venue.zoom_level = zoom;
        event.mti_show_id = undefined;
        event.payout_created = undefined;
        event.max_event_datetime = undefined;
        event.license_data = undefined;
        event.quantity_stream_tickets = undefined;
        let data = event;
        const updateVenueResponse = await saveZoom(venue, eventId);
        console.log('updateVenueResponse: ', updateVenueResponse);
        if (updateVenueResponse.data.success) {
            this.setMessage('Success!', 'Your venue has been updated.', 'success');
            setTimeout(() => {
                this.setMessage('', '', '');
            }, 3000);
        }
        async function saveZoom(venue, eventId) {
            let query = `/events/${eventId}`;
            return await ApiRequest(query, {
                method: 'PUT',
                data,
            });
        }
    };

    isDisplayCart = () => !this.props.user.role || (this.props.user.role && this.state.cartItems.length > 0);

    componentDidMount() {
        this.setMessage('', '', 'loading');

        (async () => {
            let clientId;
            try {
                if (this.props.routeProps && this.props.routeProps.match.params.id) {
                    clientId = this.props.routeProps.match.params.id;
                    console.log(this.props.routeProps, clientId);
                }

                if (this.props.user.role) {
                    this.getAllEventsList();
                }

                const responseCurrentClient = await this.getCurrentClient(clientId);
                console.log('Get Current Client: ', responseCurrentClient);
                this.props.setGlobalCurrentClient(responseCurrentClient.data.client);
                localStorage.setItem('client', JSON.stringify(responseCurrentClient.data.client));

                if (!this.props.user.role) {
                    this.props.startPatronTimer(parseInt(responseCurrentClient.data.client.id));
                }
                
                await this.setState({
                    client: responseCurrentClient.data.client || {}
                }, () => {
                    /* if (!this.props.user.role) {
                        console.log('this.state.client.billing_country', this.state.client.billing_country)
                        this.state.client.billing_country === 'CA' ? stripePromise = loadStripe(process.env.REACT_APP_STRIPE_CAN) : stripePromise = loadStripe(process.env.REACT_APP_STRIPE_US);
                        console.log('stripePromise', stripePromise)
                    } */
                });

                const customer = {...this.state.customer};
                customer['mailing_list'] = responseCurrentClient.data.client && responseCurrentClient.data.client.collect_cust_info !== '' ? responseCurrentClient.data.client.collect_cust_info : true;
                this.setState({ customer });

                const responseEvents = await this.getClientEvents(this.state.client.id, this.props.user, 'active');
                console.log('Get Events Response: ', responseEvents.data.events);

                const responseFlexpass = await getClientFlexpass(this.state.client.id, this.props.user);
                console.log('Get Flexpass Response: ', responseFlexpass.data.flexpasses);

                if (!responseEvents.data.error && !responseFlexpass.data.error) {
                    const alignedEvents = this.setEarlyPayoutToActiveStatus(responseEvents.data.events);
                    console.log(alignedEvents);
                    this.setMessage('', '', '');
                    this.setState({
                        events: alignedEvents || [],
                        flexpasses: responseFlexpass.data.flexpasses || []
                    });

                    const action = new URLSearchParams(window.location.search).get('action');

                    if (action) {
                        this.executeUrlAction(action);
                    } else {
                        this.redirectToSingleEventIfOnlyOneActive();
                    }
                } else {
                    this.setMessage(window.general_strings.msg.oops, strings.somethingWentWrong, 'error');
                    setTimeout(() => {
                        this.setMessage('', '', '');
                    }, 3000);
                }

                const fees_and_discounts = { ...this.state.fees_and_discounts }
                if (!this.props.user.role) {
                    fees_and_discounts['shipping'] = 'print';
                    customer['mailing_list'] = true;
                } else {
                    fees_and_discounts['shipping'] = 'print';
                }

                this.setState({ fees_and_discounts }, async () => {
                    const ticketsInCartResponse = await this.getTicketsInCart(this.props.user) || [];
                    console.log('Tickets in cart: ', ticketsInCartResponse);
                    
                    let nullPricingArray = []; 
                    ticketsInCartResponse.forEach(event => {
                        event.forEach(ticket => {
                            if(ticket.pricing_option_id === null) {
                                nullPricingArray.push(ticket);
                            }
                        });
                    });

                    if (nullPricingArray.length > 0) {
                        nullPricingArray.forEach(async (ticket) => {
                            await this.deleteFromCart(ticket);
                        });
                    } else {
                        const cartPricingResponse = await this.getCartPricing(this.props.user);
                        console.log('Cart pricing: ', cartPricingResponse);
                    }

                    if(this.props.user.role && this.state.cartItems.length > 0) {
                        this.props.startClientTimer(this.state.cartItems);
                    }
                });

                const responseTags = await getClientTags(this.state.client.id, this.props.user);
                console.log('Get Tags Response: ', responseTags.data.tags);

                const responseQuestions = await getClientQuestions(this.state.client.id, this.props.user);
                console.log('Get Questions Response: ', responseQuestions.data.questions);
                let responseQuestionsFiltered = [];
                let hasQuestionNotAnswered = this.state.hasQuestionNotAnswered;
                responseQuestions.data.questions.forEach((question) => {
                    if (question.status === 'active') {
                        question.answer = '';
                        responseQuestionsFiltered.push(question);
                        if (question.required) {
                            hasQuestionNotAnswered = true;
                        }
                    }
                });

                await this.detectDymoPrinter();

                if (this.props.user.role) {
                    setTimeout(() => {
                        this.detectBocaPrinter();
                        this.detectStarPrinter();
                    }, 3000);
                }

                this.setState({
                    hasQuestionNotAnswered,
                    tags: responseTags.data.tags || [],
                    questions: responseQuestionsFiltered || []
                }, () => {
                    this.baseState = DeepCopy(this.state);
                    console.log(this.baseState);
                    const isCategoryOpen = { ...this.state.isCategoryOpen };
                    isCategoryOpen['active'] = true;
                    this.setState({ isCategoryOpen });

                    this.populatePreselectedDate(false);
                });

            } catch (error) {
                console.log(error);
            }
        })()

        async function getClientFlexpass(clientId = '', user) {
            let query;
            user.role ? query = '/flexpass' : query = `/flexpass-listing/${clientId}`;
            return await ApiRequest(query);
            //return await ApiRequest(`/flexpass`);
        }

        async function getClientTags(clientId = '', user) {
            let query;
            user.role ? query = '/tags' : query = `/clients/${clientId}/tags`;
            return await ApiRequest(query);
        } 
        
        async function getClientQuestions(clientId = '', user) {
            let query;
            user.role ? query = '/client-questions' : query = `/client-questions`;
            return await ApiRequest(query);
        } 

        // if isDonation
        if (this.props.isDonation) {
            this.openDonationBilling();
        }
    }

    componentWillReceiveProps(props) {
        if(props.isQueue){
            // Set Queue mode
            this.setState({ isQueue:props.isQueue });
        }

        if (props.isDonation) {
            this.openDonationBilling();
        }
    }

    componentWillMount() {
        this.checkIfBrowserSupported();
    }

    checkIfBrowserSupported = () => {
        // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/false || !!document.documentMode;
        this.setState({ isBrowserNotSupportedModalOpen: isIE });
    };

    redirectToSingleEventIfOnlyOneActive = () => {
        const urlParams = new URLSearchParams(window.location.search);
        console.log('urlParams', urlParams)
        let hasVIPPatronToken = false;
        if (urlParams.get('token') && urlParams.get('token') !== '') {
            hasVIPPatronToken = true;
        }
        console.log('hasVIPPatronToken', hasVIPPatronToken)
        
        if((this.props.user.role === 'box-office' || this.props.user.role == 'client') || (urlParams.get('event') || urlParams.get('date'))) return;

        let activeEvents = [];
        this.state.events.map((event) => {
            if (event.status === "active") {
                activeEvents.push(event);
            }
        });
        this.state.flexpasses.map((flexpass) => {
            if (flexpass.status === "active") {
                activeEvents.push(flexpass);
            }
        });
        if(activeEvents.length === 1 && !this.props.isDonation) {
            if (!hasVIPPatronToken) {
                this.props.routeProps.history.push(`/event-details/${activeEvents[0].id}`);
            }
            
        }
    };

    executeUrlAction = (action) => {
        console.log("ACTION ===", action);
        if (action === 'donation') {
            this.props.makeDonation();
        }
    };

    setIsPaymentEnabled = (value) => {
        let isPaymentEnabled = this.state.isPaymentEnabled;
        isPaymentEnabled = value;
        this.setState({
            isPaymentEnabled,
        });
    }

    populatePreselectedDate = (bypassPasswordFirstStep) => {
        // If there is a date id and event id
        if (this.props.routeProps.location.search) {
            const isCategoryOpen = { ...this.state.isCategoryOpen };
            isCategoryOpen['active'] = false;
            this.setState({ isCategoryOpen });
            const search = this.props.routeProps.location.search.substring(1).split("&").reduce(function(result, value) {
                var parts = value.split('=');
                if (parts[0]) result[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
                return result;
            }, {})
            console.log('search', search);
            const eventId = search.event;
            const dateId = search.date;
            const flexpassId = search.flexpass;
            let dateIndex = 0;
            let showPresalePasswordModal = false;
            let hasPresalePassword = false;
            let passwordFakeEvent = {};

            this.state.events.forEach((event) => {
                if (parseInt(event.id, 10) === parseInt(eventId, 10)) {
                    event.event_dates.forEach((date, index) => {
                        if (parseInt(date.id, 10) === parseInt(dateId, 10)) {
                            if(!bypassPasswordFirstStep) {
                                hasPresalePassword = date.presale_password !== '';
                                let localUTC = moment().utc();
                                let timezone = ReturnTimeZone(date.timezone || 'EST');
                                let venueDateTimeUTCPresaleStart = moment(date.presale_start).tz(timezone);
                                let venueDateTimeUTCPresaleEnd = moment(date.presale_end).tz(timezone);
                                let venueDateTimeUTCSaleStart = moment(date.sale_start).tz(timezone);
                                let presaleHasEnded = localUTC.isAfter(venueDateTimeUTCPresaleEnd);
                                //showPresalePasswordModal = hasPresalePassword && !presaleHasEnded && venueDateTimeUTCPresaleEnd.isBefore(venueDateTimeUTCSaleStart);
                                showPresalePasswordModal = hasPresalePassword && !presaleHasEnded && localUTC.isBetween(venueDateTimeUTCPresaleStart, venueDateTimeUTCPresaleEnd);
                                if(showPresalePasswordModal) {
                                    passwordFakeEvent = {
                                        triggerFromUrl: true,
                                        event_id: parseInt(event.id, 10),
                                        date_id: parseInt(date.id, 10)
                                    }
                                }
                            }
                            dateIndex = index;
                        }
                    });
                }
            });

            if(showPresalePasswordModal) {
                this.togglePassword(passwordFakeEvent);
            } else {
                if (flexpassId) {
                    this.populateTicketSelection(flexpassId, undefined, 'flexpass');
                } else {
                    this.populateTicketSelection(eventId, dateIndex);
                }
            }
        }
    };

    clearReaderDisplay = async () => {
        if (this.state.isTerminalConnected) {
            if (this.state.checkoutInProgress) {
                await terminal.cancelCollectPaymentMethod();
            }
            await terminal.clearReaderDisplay();
        }
    }

    cancelCart = async () => {
        await this.emptyCart();
        this.setState({ isTimerUpOpen: !this.state.isTimerUpOpen }, () => {
            if (this.state.isTimerUpOpen === false) {
                this.resetTimer();
            }
        });
    }

    handleSelectLimit = (e, status) => {
        const value = e.target.value;
        let limit = this.state.limit;
        limit[status] = value;
        this.setState({
            limit,
        });
    }

    handleSelectPage = (e, status) => {
        const value = e.target.value;
        let page = this.state.page;
        page[status] = value;
        this.setState({
            page,
        });
    }

    render() {
        const current_client_id = parseInt(this.props.routeProps.match.params.id, 0);
        localStorage.setItem('current_client_id', current_client_id);
        let categories;
        if (this.props.is_client) {
            categories = this.state.categories;
        } else {
            categories = categories = [{ name: "active" }];
        }
        this.getUserIP();
        return (
            <div className={this.props.user.role ? 'is-' + this.props.user.role : 'is-patron'}>
                {this.state.isQueue &&
                    <div className="showtix-loader-queue">
                        <div className="showtix-loader"></div>
                        <h3>{strings.queue}</h3>
                        <p>{ReactHtmlParser(strings.queue2)}</p>
                        <p>{strings.yourIp}: {this.state.ip}</p>
                    </div>
                }
                <PasswordModal
                    togglePassword={this.togglePassword}
                    checkPresalePassword={this.checkPresalePassword}
                    populateTicketSelection={this.populateTicketSelection}
                    populatePreselectedDate={this.populatePreselectedDate}
                    isPasswordOpen={this.state.isPasswordOpen}
                    isPasswordOpenFromUrl={this.state.isPasswordOpenFromUrl}
                    eventPasswordId={this.state.eventPasswordId}
                />
                <TimerUpModal
                    toggleTimerUp={this.toggleTimerUp}
                    isTimerUpOpen={this.state.isTimerUpOpen}
                />
                <NoTicketsModal
                    toggleNoTickets={this.toggleNoTickets}
                    isNoTicketsOpen={this.state.isNoTicketsOpen}
                />
                <ConfirmDeleteEventModal
                    isDeleteEventOpen={this.state.isDeleteEventOpen}
                    toggleConfirmDeleteEvent={this.toggleConfirmDeleteEvent}
                    confirmConfirmDeleteEvent={this.confirmConfirmDeleteEvent}
                />
                <ConfirmDeleteFlexpassModal
                    isDeleteFlexpassOpen={this.state.isDeleteFlexpassOpen}
                    toggleConfirmDeleteFlexpass={this.toggleConfirmDeleteFlexpass}
                    confirmConfirmDeleteFlexpass={this.confirmConfirmDeleteFlexpass}
                />
                <ConfirmEarlyPayoutModal
                    isEarlyPayoutOpen={this.state.isEarlyPayoutOpen}
                    showEarlyPayoutConfirmation={this.state.showEarlyPayoutConfirmation}
                    toggleConfirmEarlyPayout={this.toggleConfirmEarlyPayout}
                    confirmConfirmEarlyPayout={this.confirmConfirmEarlyPayout}
                />
                <EventWidgetModal
                    toggleWidgetModal={this.toggleWidgetModal}
                    isToggleWidgetModalOpen={this.state.isToggleWidgetModalOpen}
                    widgetModalEventID={this.state.widgetModalEventID}
                    widgetModalEventName={this.state.widgetModalEventName}
                    current_client_id={this.state.client.id}
                />
                <BrowserNotSupportedModal
                    toggleBrowserNotSupportedModal={this.toggleBrowserNotSupportedModal}
                    isBrowserNotSupportedModalOpen={this.state.isBrowserNotSupportedModalOpen}
                />

                <StreamingWarningModal
                    toggleStreamingWarningModal={this.toggleStreamingWarningModal}
                    isVODWarning={this.state.isVODWarning}
                    isLiveStreamingWarning={this.state.isLiveStreamingWarning}
                    isScheduledContentWarning={this.state.isScheduledContentWarning}
                    selectedEvent={this.state.selectedEvent}
                    selectedDate={this.state.selectedDate}
                />

                <StripeDeviceSelect
                    toggleStripeDeviceModal={this.toggleStripeDeviceModal}
                    isStripeDeviceSelectOpen={this.state.isStripeDeviceSelectOpen}
                />

                <FlexpassDetailsModal
                    toggleFlexpassDetailsModal={this.toggleFlexpassDetailsModal}
                    isFlexpassDetailsModalOpen={this.state.isFlexpassDetailsModalOpen}
                    flexpassDetails={this.state.flexpassDetails}
                    fees_and_discounts={this.state.fees_and_discounts}
                    handleFlexpassAmount={this.handleFlexpassAmount}
                    getCartPricing={this.getCartPricing}
                    user={this.props.user}
                />

                <div className="container">
                    <div aria-live="polite">
                        <Message
                            message={this.state.message}
                        />
                    </div>
                    <div className="sr-only">Please be aware that you have a 10 minutes limit to make your purchase.</div>
                </div>
                <div className="showtix-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-9 text-center">
                                <h1>{this.state.client.client_name}</h1>
                                {categories.map((category, i) =>
                                    <EventCategory
                                        client={this.props.client}
                                        user={this.props.user}
                                        is_client={this.props.is_client}
                                        current_client_id = {current_client_id}
                                        client_name={this.state.client.client_name}
                                        key={"category_"+i}
                                        category={category}
                                        events={this.state.events}
                                        isCategoryOpen={this.state.isCategoryOpen}
                                        isConfirmationOpen={this.state.isConfirmationOpen}
                                        toggleCategory={this.toggleCategory}
                                        toggleAllCategories={this.toggleAllCategories}
                                        toggleDetails={this.toggleDetails}
                                        toggleDate={this.toggleDate}
                                        toggleAllDates={this.toggleAllDates}
                                        toggleDateSettings={this.toggleDateSettings}
                                        populateTicketSelection={this.populateTicketSelection}
                                        toggleConfirmDeleteEvent={this.toggleConfirmDeleteEvent}
                                        toggleConfirmEarlyPayout={this.toggleConfirmEarlyPayout}
                                        handlePrinterChange={this.handlePrinterChange}
                                        currentPrinter={this.state.currentPrinter}
                                        printers={this.state.printers}
                                        handlePrinterChangeBoca={this.handlePrinterChangeBoca}
                                        currentPrinterBoca={this.state.currentPrinterBoca}
                                        printersBoca={this.state.printersBoca}
                                        getAccountEventReport={this.getAccountEventReport}
                                        getStreamAccessReport={this.getStreamAccessReport}
                                        getTicketPriceSummary={this.getTicketPriceSummary}
                                        getTicketBreakdown={this.getTicketBreakdown}
                                        getArtistCreditReport={this.getArtistCreditReport}
                                        getQuestionTagReport={this.getQuestionTagReport}
                                        getSeatingReport={this.getSeatingReport}
                                        getVenueSeatLabel={this.getVenueSeatLabel}
                                        getHouseCount={this.getHouseCount}
                                        flexpasses={this.state.flexpasses}
                                        togglePassword={this.togglePassword}
                                        toggleConfirmDeleteFlexpass={this.toggleConfirmDeleteFlexpass}
                                        setMessage={this.setMessage}
                                        toggleWidgetModal={this.toggleWidgetModal}
                                        isToggleWidgetModalOpen={this.state.isToggleWidgetModalOpen}
                                        limit={this.state.limit}
                                        page={this.state.page}
                                        handleSelectLimit={this.handleSelectLimit}
                                        handleSelectPage={this.handleSelectPage}
                                        updateCategoryEvents={this.updateCategoryEvents}
                                        printersStar={this.state.printersStar}
                                        printersStarUSB={this.state.printersStarUSB}
                                        currentPrinterStar={this.state.currentPrinterStar}
                                        handlePrinterChangeStar={this.handlePrinterChangeStar}
                                    />)
                                }
                                <div className="container">
                                    <Message
                                        message={this.state.message}
                                    />
                                </div>
                                {this.state.ticketSelection.type === 'reserved' ?
                                    <ReservedSeating
                                        isTicketsOpen={this.state.isTicketsOpen}
                                        ticketSelection={this.state.ticketSelection}
                                        updateTicketsInCart={this.updateTicketsInCart}
                                        postReservedAdmissionTickets={this.postReservedAdmissionTickets}
                                        deleteFromCart={this.deleteFromCart}
                                        isCategoryOpen={this.state.isCategoryOpen}
                                        toggleCategory={this.toggleCategory}
                                        cartItems={this.state.cartItems}
                                        toggleBilling={this.toggleBilling}
                                        toggleTickets={this.toggleTickets}
                                        refresh={this.state.refresh}
                                        user={this.props.user}
                                        current_client_id={current_client_id}
                                        handleCreditsSelection={this.handleCreditsSelection}
                                        saveZoomLevel={this.saveZoomLevel}
                                    /> :
                                    (this.state.ticketSelection.type === 'general-admission' ||
                                        this.state.ticketSelection.type === 'flexpass') &&
                                        <GeneralSeating
                                            isTicketsOpen={this.state.isTicketsOpen}
                                            billing={this.state.billing}
                                            events={this.state.events}
                                            flexpasses={this.state.flexpasses}
                                            user={this.props.user}
                                            ticketSelection={this.state.ticketSelection}
                                            clearTicketSelection={this.clearTicketSelection}
                                            handleTicketSelection={this.handleTicketSelection}
                                            handleCreditsSelection={this.handleCreditsSelection}
                                            cartItems={this.state.cartItems}
                                            updateTicketsInCart={this.updateTicketsInCart}
                                            toggleBilling={this.toggleBilling}
                                            toggleTickets={this.toggleTickets}
                                            isCategoryOpen={this.state.isCategoryOpen}
                                            toggleCategory={this.toggleCategory}
                                            max_seats={this.state.max_seats}
                                            toggleNoTickets={this.toggleNoTickets}
                                            isNoTicketsOpen={this.state.isNoTicketsOpen}
                                            isCheckoutDisabled={this.state.isCheckoutDisabled}
                                        />
                                }
                                {/* <Elements stripe={stripePromise}> */}
                                    <EventBilling
                                        is_client={this.props.is_client}
                                        billing={this.state.billing}
                                        client={this.state.client}
                                        call_center_fee={this.state.call_center_fee}
                                        handleServiceFee={this.handleServiceFee}
                                        service_fee={this.state.service_fee}
                                        setCallCenterFees={this.setCallCenterFees}
                                        toggleBilling={this.toggleBilling}
                                        toggleCustomerInfo={this.toggleCustomerInfo}
                                        isBillingOpen={this.state.isBillingOpen}
                                        isCustomerInfoOpen={this.state.isCustomerInfoOpen}
                                        handleEventBilling={this.handleEventBilling}
                                        applyCoupon={this.applyCoupon}
                                        applyDonation={this.applyDonation}
                                        removeCoupon={this.removeCoupon}
                                        removeFlexpass={this.removeFlexpass}
                                        validation={this.state.validation}
                                        validateRequiredField={this.validateRequiredField}
                                        checkout={this.checkout}
                                        fees_and_discounts={this.state.fees_and_discounts}
                                        handleDonationCouponsAndFlexpass={this.handleDonationCouponsAndFlexpass}
                                        handleShippingFee={this.handleShippingFee}
                                        setShippingFeeToPrint={this.setShippingFeeToPrint}
                                        cartItems={this.state.cartItems}
                                        getCartPricing={this.getCartPricing}
                                        user={this.props.user}
                                        isGodMode={this.props.isGodMode}
                                        handleFlexpassAmount={this.handleFlexpassAmount}
                                        isDonation={this.props.isDonation}
                                        hasQuestionNotAnswered={this.state.hasQuestionNotAnswered}
                                        routeProps={this.props.routeProps}
                                        isTerminalConnected={this.state.isTerminalConnected}
                                        cartPricing={this.state.cartPricing}
                                        checkoutInProgress={this.state.checkoutInProgress}
                                        checkoutStripePayment={this.checkoutStripePayment}
                                        stripeRequestPayment={this.state.stripeRequestPayment}
                                        setIsPaymentEnabled={this.setIsPaymentEnabled}
                                        isPaymentEnabled={this.state.isPaymentEnabled}
                                        questions={this.state.questions}
                                        handleChangeQuestionAnswer={this.handleChangeQuestionAnswer}
                                    />
                                {/* </Elements> */}

                                <EventCustomer
                                    client={this.state.client}
                                    is_client={this.props.is_client}
                                    user={this.props.user}
                                    toggleCustomerInfo={this.toggleCustomerInfo}
                                    isCustomerInfoOpen={this.state.isCustomerInfoOpen}
                                    handleCustomerInformation={this.handleCustomerInformation}
                                    handleCustomerAddress={this.handleCustomerAddress}
                                    handleFullCustomerAddress={this.handleFullCustomerAddress}
                                    updateCustomerFromAutocompleteInput={this.updateCustomerFromAutocompleteInput}
                                    searchCustomers={this.searchCustomers}
                                    selectCustomer={this.selectCustomer}
                                    validate={this.validate}
                                    invalidatePhysicalMailing={this.invalidatePhysicalMailing}
                                    validation={this.state.validation}
                                    validateRequiredField={this.validateRequiredField}
                                    billing={this.state.billing}
                                    customer={this.state.customer}
                                    customers={this.state.customers}
                                    isCustomerEditingMode={this.state.isCustomerEditingMode}
                                    toggleCustomerEditingMode={this.toggleCustomerEditingMode}
                                    handleChangeFilter={this.handleChangeFilter}
                                    tags={this.state.tags}
                                    selectedTags={this.state.selectedTags}
                                    
                                    checkout={this.checkout}
                                    isReadyToSubmit={this.state.isReadyToSubmit}
                                    returnStripeToken={this.returnStripeToken}
                                    fees_and_discounts={this.state.fees_and_discounts}
                                    isReset={this.state.isReset}
                                    cartPricing={this.state.cartPricing}
                                    cartItems={this.state.cartItems}
                                    totalItemsInCart={this.props.totalItemsInCart}
                                    isDisplayCart={this.isDisplayCart}
                                    isConfirmationOpen={this.state.isConfirmationOpen}
                                    deleteFromCart={this.deleteFromCart}
                                    updateTicketsInCart={this.updateTicketsInCart}
                                    hasQuestionNotAnswered={this.state.hasQuestionNotAnswered}
                                />

                                <EventConfirmation
                                    user={this.props.user}
                                    isConfirmationOpen={this.state.isConfirmationOpen}
                                    confirmationNumber={this.state.confirmationNumber}
                                    sellMoreTickets={this.sellMoreTickets}
                                    continueShopping={this.continueShopping}
                                    handlePrinterChange={this.handlePrinterChange}
                                    currentPrinter={this.state.currentPrinter}
                                    printers={this.state.printers}
                                    lastPaymentMethod={this.state.lastPaymentMethod}
                                    patronTicketURL={this.state.patronTicketURL}
                                    shipping={this.state.lastShippingMethod}
                                    confirmationEvent={this.state.confirmationEvent}
                                    currentPrinterBoca={this.state.currentPrinterBoca}
                                    printersBoca={this.state.printersBoca}
                                    handlePrinterChangeBoca={this.handlePrinterChangeBoca}
                                    printersStar={this.state.printersStar}
                                    printersStarUSB={this.state.printersStarUSB}
                                    currentPrinterStar={this.state.currentPrinterStar}
                                    handlePrinterChangeStar={this.handlePrinterChangeStar}
                                    token={this.state.token}
                                />
                            </div>

                            <div className="col-12 col-md-3">
                                {this.isDisplayCart() && !this.state.isConfirmationOpen &&
                                    <Cart
                                        cartItems={this.state.cartItems}
                                        cartPricing={this.state.cartPricing}
                                        call_center_fee={this.state.call_center_fee}
                                        isCartOpen={this.props.isCartOpen}
                                        updateTicketsInCart={this.updateTicketsInCart}
                                        deleteFromCart={this.deleteFromCart}
                                        clearDonationFromCart={this.clearDonationFromCart}
                                        checkout={this.checkout}
                                        events={this.state.events}
                                        toggleBilling={this.toggleBilling}
                                        toggleCategory={this.toggleCategory}
                                        toggleTickets={this.toggleTickets}
                                        isBillingOpen={this.state.isBillingOpen}
                                        isTicketsOpen={this.state.isTicketsOpen}
                                        isCategoryOpen={this.state.isCategoryOpen}
                                        timer={this.props.timer}
                                        toggleTimerUp={this.toggleTimerUp}
                                        emptyCart={this.emptyCart}
                                        totalItemsInCart={this.props.totalItemsInCart}
                                        billing={this.state.billing}
                                        user={this.props.user}
                                        terminal={terminal}
                                        clearReaderDisplay={this.clearReaderDisplay}
                                        cancelCart={this.cancelCart}
                                        isCustomerInfoOpen={this.state.isCustomerInfoOpen}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

EventListing.propTypes = {
    isDonation: PropTypes.bool,
    is_client: PropTypes.bool,
    isCartOpen: PropTypes.bool,
    cartItems: PropTypes.array,
    emptyCart: PropTypes.func,
    updateTicketsInCart: PropTypes.func,
}

export default EventListing;



// WEBPACK FOOTER //
// ./src/components/EventListing/EventListing.js